import React, {useEffect, useMemo, useRef, useState} from 'react';
import AuthService from '../Services/AuthService';
import {toast} from 'react-toastify';
import {css} from 'glamor';
import './PreRegistroStep1.css';

const signedInErrorMsg = 'Ya iniciaste sesión como presentador. Esta página es solo para PreRegistros.';
const noRecruiterErrorMsg = 'No se encontró la referencia de un reclutador.';
const curpInvalidMsg = 'CURP no válido.';
const curpRegex = /^[A-Z]{4}[0-9]{6}[HM][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[A-Z0-9][0-9]$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const securePasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
const manualRfcRegex = /^([A-ZÑ&]{3,4})(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([A-Z\d]{3})$/;
const maxUploadSizeBytes = 10 * 1024 * 1024;
const allowedUploadMimeTypes = ['image/jpeg', 'image/png', 'image/tiff', 'application/pdf'];
const allowedUploadExtensions = ['jpg', 'jpeg', 'png', 'tif', 'tiff', 'pdf'];
const preRegSessionTTLms = 24 * 60 * 60 * 1000;
const preRegSigningTTLms = 15 * 60 * 1000;
const preRegSigningKey = 'pre_registration_signing';
const preRegSigningExpiresKey = 'pre_registration_signing_expires_at';
const shopBaseUrl = (process.env.REACT_APP_SHOP_BASE_URL || 'https://shop-stage.thermomix.mx').replace(/\/+$/, '');
const preRegSessionKeys = {
  user: 'pre_registration_user',
  email: 'pre_registration_email',
  curp: 'pre_registration_curp',
  name: 'pre_registration_name',
  ObjectId: 'pre_registration_ObjectId',
  expiresAt: 'pre_registration_expires_at',
};
const preRegLookupKeys = {
  result: 'pre_registration_lookup_result',
  type: 'pre_registration_lookup_type',
};
const programFinalSteps = [
  'Validando Datos',
  'Revisando contrato',
  'Enviando Información',
  'Actualizando Cuenta de eShop',
];
const programFinalStepMinDurationMs = 2000;
const programFinalMessageDelayMs = 1200;
const estadosOptions = [
  { label: 'Aguascalientes', value: 'AGS' },
  { label: 'Baja California', value: 'BC' },
  { label: 'Baja California Sur', value: 'BCS' },
  { label: 'Campeche', value: 'CAM' },
  { label: 'Chiapas', value: 'CHIS' },
  { label: 'Chihuahua', value: 'CHIH' },
  { label: 'Ciudad de México', value: 'Ciudad de México' },
  { label: 'Coahuila', value: 'COAH' },
  { label: 'Colima', value: 'COL' },
  { label: 'Durango', value: 'DGO' },
  { label: 'Guanajuato', value: 'GTO' },
  { label: 'Guerrero', value: 'GRO' },
  { label: 'Hidalgo', value: 'HGO' },
  { label: 'Jalisco', value: 'JAL' },
  { label: 'Michoacan', value: 'MICH' },
  { label: 'Morelos', value: 'MOR' },
  { label: 'Estado de México', value: 'MEX' },
  { label: 'Nayarit', value: 'NAY' },
  { label: 'Nuevo Leon', value: 'NL' },
  { label: 'Oaxaca', value: 'OAX' },
  { label: 'Puebla', value: 'PUE' },
  { label: 'Queretaro', value: 'QRO' },
  { label: 'Quintana Roo', value: 'QROO' },
  { label: 'San Luis Potosi', value: 'SLP' },
  { label: 'Sinaloa', value: 'SIN' },
  { label: 'Sonora', value: 'SON' },
  { label: 'Tabasco', value: 'TAB' },
  { label: 'Tamaulipas', value: 'TAMPS' },
  { label: 'Tlaxcala', value: 'TLAX' },
  { label: 'Veracruz', value: 'VER' },
  { label: 'Yucatan', value: 'YUC' },
  { label: 'Zacatecas', value: 'ZAC' },
];
const bancoOptions = [
  { label: 'AMERICAN EXPRESS', value: '1' },
  { label: 'CITIBANK MEXICO', value: '2' },
  { label: 'BANCO AZTECA', value: '3' },
  { label: 'HSBC', value: '4' },
  { label: 'BANCO COMERCIAL PORTUGAL', value: '5' },
  { label: 'BBVA BANCOMER', value: '6' },
  { label: 'IXE BANCO', value: '7' },
  { label: 'BANK OF AMERICA', value: '8' },
  { label: 'SCOTIABANK', value: '9' },
  { label: 'SANTANDER MEXICANO', value: '10' },
  { label: 'CREDIT SUISSE', value: '11' },
  { label: 'COMMERZBANK', value: '12' },
  { label: 'DEUTSCHE BANK', value: '13' },
  { label: 'BANORTE', value: '14' },
  { label: 'INBURSA', value: '16' },
  { label: 'CITIBANK NA', value: '17' },
  { label: 'INTERACCIONES', value: '18' },
  { label: 'Banxico', value: '19' },
  { label: 'Bancomext', value: '20' },
  { label: 'Banobras', value: '21' },
  { label: 'Banjercito', value: '22' },
  { label: 'GE Capital', value: '23' },
  { label: 'Del Sureste', value: '24' },
  { label: 'Del Bajio', value: '25' },
  { label: 'Mifel', value: '26' },
  { label: 'Quadrum', value: '27' },
  { label: 'Banregio', value: '28' },
  { label: 'Invex', value: '29' },
  { label: 'Bansi', value: '30' },
  { label: 'Afirme', value: '31' },
  { label: 'Bancen', value: '32' },
  { label: 'The Royal Bank Of Scotland', value: '33' },
  { label: 'Boston', value: '34' },
  { label: 'Tokyo', value: '35' },
  { label: 'JP Morgan', value: '36' },
  { label: 'Banco Monex', value: '37' },
  { label: 'VE POR MAS', value: '38' },
  { label: 'Bank One', value: '39' },
  { label: 'Ing Bank', value: '40' },
  { label: 'Deutsche', value: '41' },
  { label: 'Autofin Mexico', value: '42' },
  { label: 'Barclays', value: '43' },
  { label: 'Banco Compartamos', value: '44' },
  { label: 'Ahorro FAMSA', value: '45' },
  { label: 'Multiva', value: '46' },
  { label: 'Prudential', value: '47' },
  { label: 'Wal-Mart', value: '48' },
  { label: 'Nafinsa', value: '49' },
  { label: 'Regional', value: '50' },
  { label: 'Coppel', value: '51' },
  { label: 'Banco Amigo', value: '52' },
  { label: 'UBS', value: '53' },
  { label: 'Banco Facil', value: '54' },
  { label: 'Volkswagen', value: '55' },
  { label: 'El Banco Deuno', value: '56' },
  { label: 'Consultoria Internacional Banco', value: '57' },
  { label: 'Banrural', value: '58' },
  { label: 'Bansefi', value: '59' },
  { label: 'Hipotecaria FED', value: '60' },
  { label: 'Monex', value: '61' },
  { label: 'GBM', value: '62' },
  { label: 'Masari', value: '63' },
  { label: 'Value', value: '64' },
  { label: 'Tiber', value: '65' },
  { label: 'Vector', value: '66' },
  { label: 'BYB', value: '67' },
  { label: 'Intercam', value: '68' },
  { label: 'Multivalores', value: '69' },
  { label: 'Accival', value: '70' },
  { label: 'Merril Lynch', value: '71' },
  { label: 'FINAMEX', value: '72' },
  { label: 'Valores Mexicanos', value: '73' },
  { label: 'Unica', value: '74' },
  { label: 'MAPFRE', value: '75' },
  { label: 'Profuturo GNP', value: '76' },
  { label: 'Actinver', value: '77' },
  { label: 'Actinver Sociedad Operadora', value: '78' },
  { label: 'Skandia Vida', value: '79' },
  { label: 'Casa de Cambio Tamibe', value: '80' },
  { label: 'Deustche Securities Casa de Bolsa', value: '81' },
  { label: 'Zurich Compania de Seguros', value: '82' },
  { label: 'Zurich Vida, Compania de Seguros', value: '83' },
  { label: 'Hipotecaria Su Casita', value: '84' },
  { label: 'Intercam Casa de Bolsa', value: '85' },
  { label: 'Vanguardia Casa de Bolsa', value: '86' },
  { label: 'Sterling Casa de Cambio', value: '87' },
  { label: 'Servicios Financieros Comunitarios', value: '88' },
  { label: 'Order Express Casa de Cambio, S.A. de C.V', value: '89' },
  { label: 'Akala, S.A de C.V', value: '90' },
  { label: 'J.P. Morgan Casa de Bolsa', value: '91' },
  { label: 'Tiber SOFOM', value: '92' },
  { label: 'Casa de Bolsa Banorte', value: '93' },
  { label: 'SOFOM STP', value: '94' },
  { label: 'INDEVAL', value: '95' },
  { label: 'BAYERISCHE HYPO UND', value: '119' },
  { label: 'BANCO DEL BAJIO', value: '120' },
  { label: 'BANCA MIFEL', value: '121' },
  { label: 'AFIRME', value: '122' },
  { label: 'BANBAJIO', value: '123' },
  { label: 'Guardadito Vista', value: '124' },
  { label: 'LIBERTAD SERVICIOS FINANCIEROS', value: '125' },
  { label: 'MI BANCO', value: '126' },
  { label: 'STP', value: '127' },
  { label: 'CONSUBANCO', value: '128' },
  { label: 'NU', value: '129' },
  { label: 'FONDEADORA', value: '130' },
  { label: 'BANKAOOL', value: '131' },
  { label: 'SPIN BY OXXO', value: '132' },
  { label: 'ALBO', value: '133' },
  { label: 'MERCADO PAGO', value: '134' },
];

const copyTextToClipboard = async (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const fallback = document.createElement('textarea');
  fallback.value = text;
  fallback.style.position = 'fixed';
  fallback.style.left = '-9999px';
  document.body.appendChild(fallback);
  fallback.select();
  document.execCommand('copy');
  document.body.removeChild(fallback);
};

const alerts = (msg, error) => {
  toast(msg, {
    className: css({
      background: error ? '#E7332A' : '#00AC46',
      color: 'white',
    }),
    progressClassName: css({
      background: error ? '#00AC46' : 'white',
    }),
  });
};

const encodeBase64Value = (value) => {
  const stringValue = value || '';
  const bytes = new TextEncoder().encode(stringValue);
  let binaryValue = '';

  bytes.forEach((byte) => {
    binaryValue += String.fromCharCode(byte);
  });

  return window.btoa(binaryValue);
};

const resolveContractSignerName = (candidateFields) => {
  const csfName = (candidateFields.csf_Name || '').trim();
  const csfFaName = (candidateFields.csf_Fa_Name || '').trim();
  const csfMoName = (candidateFields.csf_Mo_Name || '').trim();
  const fallbackName = [candidateFields.nombres, candidateFields.apellidos].filter(Boolean).join(' ').trim();

  if (!csfName || !csfFaName || !csfMoName) {
    return fallbackName;
  }

  return [csfName, csfFaName, csfMoName].join(' ').trim();
};

const sleep = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

const isMissingCandidateValue = (value) => {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  return false;
};

const getApiErrorMessage = (error, fallbackMessage) => {
  const backendMessage = error && error.response && error.response.data && error.response.data.message;
  return backendMessage || fallbackMessage;
};

const clearPreRegistrationSession = () => {
  localStorage.removeItem(preRegSessionKeys.user);
  localStorage.removeItem(preRegSessionKeys.email);
  localStorage.removeItem(preRegSessionKeys.curp);
  localStorage.removeItem(preRegSessionKeys.name);
  localStorage.removeItem(preRegSessionKeys.ObjectId);
  localStorage.removeItem(preRegSessionKeys.expiresAt);
};

const logPreRegistrationStorage = (originLabel) => {
  const expiresAtRaw = localStorage.getItem(preRegSessionKeys.expiresAt);
  const expiresAt = Number(expiresAtRaw);
  const ttlMs = Number.isFinite(expiresAt) ? Math.max(expiresAt - Date.now(), 0) : null;

  console.log('[PreRegistro session]', {
    origin: originLabel,
    pre_registration_user: localStorage.getItem(preRegSessionKeys.user),
    pre_registration_curp: localStorage.getItem(preRegSessionKeys.curp),
    pre_registration_name: localStorage.getItem(preRegSessionKeys.name),
    pre_registration_email: localStorage.getItem(preRegSessionKeys.email),
    pre_registration_ObjectId: localStorage.getItem(preRegSessionKeys.ObjectId),
    pre_registration_expires_at: expiresAtRaw,
    pre_registration_ttl_ms: ttlMs,
  });
};

const maskEmailForDisplay = (email) => {
  const normalizedEmail = (email || '').trim();
  const parts = normalizedEmail.split('@');

  if (parts.length !== 2) {
    return normalizedEmail;
  }

  const maskSegment = (segment, prefixLength) => {
    const visibleLength = Math.max(0, Math.min(prefixLength, segment.length - 1));
    return `${segment.slice(0, visibleLength)}${'*'.repeat(segment.length - visibleLength)}`;
  };

  const [localPart, domainPart] = parts;
  const maskedLocal = maskSegment(localPart, 3);

  const domainPieces = domainPart.split('.');
  const maskedDomainPieces = domainPieces.map((piece, index) => {
    return maskSegment(piece, index === domainPieces.length - 1 && domainPieces.length > 1 ? 2 : 3);
  });

  return `${maskedLocal}@${maskedDomainPieces.join('.')}`;
};

const getActivePreRegistrationSession = () => {
  const user = localStorage.getItem(preRegSessionKeys.user);
  const email = localStorage.getItem(preRegSessionKeys.email);
  const curp = localStorage.getItem(preRegSessionKeys.curp);
  const name = localStorage.getItem(preRegSessionKeys.name);
  const ObjectId = localStorage.getItem(preRegSessionKeys.ObjectId);
  const expiresAtRaw = localStorage.getItem(preRegSessionKeys.expiresAt);

  if (!user || !curp || !name || !expiresAtRaw) {
    return null;
  }

  const expiresAt = Number(expiresAtRaw);
  if (!Number.isFinite(expiresAt) || Date.now() > expiresAt) {
    clearPreRegistrationSession();
    return null;
  }

  const resolvedEmail = email || user;
  if (!email) {
    localStorage.setItem(preRegSessionKeys.email, resolvedEmail);
  }

  return { user, email: resolvedEmail, curp, name, ObjectId, expiresAt };
};

const persistPreRegistrationSession = ({ user, email, curp, name, ObjectId }) => {
  const sessionEmail = email || user;
  localStorage.setItem(preRegSessionKeys.user, user);
  localStorage.setItem(preRegSessionKeys.email, sessionEmail);
  localStorage.setItem(preRegSessionKeys.curp, curp);
  localStorage.setItem(preRegSessionKeys.name, name);
  if (ObjectId) {
    localStorage.setItem(preRegSessionKeys.ObjectId, ObjectId);
  } else {
    localStorage.removeItem(preRegSessionKeys.ObjectId);
  }
  localStorage.setItem(preRegSessionKeys.expiresAt, String(Date.now() + preRegSessionTTLms));
};

const clearPreRegistrationSigning = () => {
  localStorage.removeItem(preRegSigningKey);
  localStorage.removeItem(preRegSigningExpiresKey);
};

const clearPreRegistrationLookup = () => {
  localStorage.removeItem(preRegLookupKeys.result);
  localStorage.removeItem(preRegLookupKeys.type);
};

const hasActivePreRegistrationSigning = () => {
  const signingValue = localStorage.getItem(preRegSigningKey);
  const signingExpiresAtRaw = localStorage.getItem(preRegSigningExpiresKey);
  const signingExpiresAt = Number(signingExpiresAtRaw);

  if (signingValue !== 'true' || !Number.isFinite(signingExpiresAt) || Date.now() > signingExpiresAt) {
    clearPreRegistrationSigning();
    return false;
  }

  return true;
};

export default function PreRegistroStep1({ isSignedIn }) {
  const initialSession = getActivePreRegistrationSession();
  const [showIntroOptions, setShowIntroOptions] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [step1Touched, setStep1Touched] = useState(false);
  const [formData, setFormData] = useState({
    nombres: '',
    apellidos: '',
    telefono: '',
    curp: '',
    tieneThermomix: '',
    vioDemo: '',
    haVendido: '',
    cualVendio: '',
  });
  const [formStep2Data, setFormStep2Data] = useState({
    descripcion: '',
    estado: '',
    ciudad: '',
    codigoPostal: '',
    colonia: '',
    calle: '',
    numeroExterior: '',
    numeroInterior: '',
    horarioDisponible: '',
  });
  const [step2Touched, setStep2Touched] = useState(false);
  const [accountEmail, setAccountEmail] = useState('');
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);
  const [step3Touched, setStep3Touched] = useState(false);
  const [candidateSignInData, setCandidateSignInData] = useState({
    email: '',
    password: '',
  });
  const [showAccountLookupScreen, setShowAccountLookupScreen] = useState(false);
  const [accountLookupError, setAccountLookupError] = useState('');
  const [accountLookupSuccess, setAccountLookupSuccess] = useState('');
  const [accountLookupResult, setAccountLookupResult] = useState(null);
  const [isSearchingAccountLookup, setIsSearchingAccountLookup] = useState(false);
  const [curpValidationError, setCurpValidationError] = useState('');
  const [isValidatingCurp, setIsValidatingCurp] = useState(false);
  const [mailValidationError, setMailValidationError] = useState('');
  const [isValidatingMail, setIsValidatingMail] = useState(false);
  const [isValidatingReingresoEmail, setIsValidatingReingresoEmail] = useState(false);
  const [candidateSignInTouched, setCandidateSignInTouched] = useState(false);
  const [isCandidateSigningIn, setIsCandidateSigningIn] = useState(false);
  const [candidateSignInError, setCandidateSignInError] = useState('');
  const [passwordData, setPasswordData] = useState({
    password: '',
    confirmPassword: '',
  });
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [isSubmittingCandidate, setIsSubmittingCandidate] = useState(false);
  const [submitCandidateError, setSubmitCandidateError] = useState('');
  const [preRegistrationSession, setPreRegistrationSession] = useState(initialSession);
  const [isSessionRedirect, setIsSessionRedirect] = useState(!!initialSession);
  const [isUploadingFotoRostro, setIsUploadingFotoRostro] = useState(false);
  const [uploadFotoRostroError, setUploadFotoRostroError] = useState('');
  const [hasUploadedFotoRostro, setHasUploadedFotoRostro] = useState(false);
  const [isUploadingIneFront, setIsUploadingIneFront] = useState(false);
  const [uploadIneFrontError, setUploadIneFrontError] = useState('');
  const [hasUploadedIneFront, setHasUploadedIneFront] = useState(false);
  const [isUploadingIneBack, setIsUploadingIneBack] = useState(false);
  const [uploadIneBackError, setUploadIneBackError] = useState('');
  const [hasUploadedIneBack, setHasUploadedIneBack] = useState(false);
  const [isUploadingCaratula, setIsUploadingCaratula] = useState(false);
  const [uploadCaratulaError, setUploadCaratulaError] = useState('');
  const [hasUploadedCaratula, setHasUploadedCaratula] = useState(false);
  const [isUploadingCsf, setIsUploadingCsf] = useState(false);
  const [uploadCsfError, setUploadCsfError] = useState('');
  const [hasUploadedCsf, setHasUploadedCsf] = useState(false);
  const [showCsfManualReviewHint, setShowCsfManualReviewHint] = useState(false);
  const [hasRequestedManualCsfReview, setHasRequestedManualCsfReview] = useState(false);
  const [csfStatus, setCsfStatus] = useState('');
  const [csfStatusTouched, setCsfStatusTouched] = useState(false);
  const [documentsTouched, setDocumentsTouched] = useState(false);
  const [manualRfc, setManualRfc] = useState('');
  const [manualRfcTouched, setManualRfcTouched] = useState(false);
  const [clabe, setClabe] = useState('');
  const [banco, setBanco] = useState('');
  const [hasSavedBanco, setHasSavedBanco] = useState(false);
  const [isSavingBanco, setIsSavingBanco] = useState(false);
  const [confirmarClabe, setConfirmarClabe] = useState('');
  const [clabeTouched, setClabeTouched] = useState(false);
  const [savedClabeBancaria, setSavedClabeBancaria] = useState('');
  const [isSubmittingClabe, setIsSubmittingClabe] = useState(false);
  const [submitClabeError, setSubmitClabeError] = useState('');
  const [showTmLitePopup, setShowTmLitePopup] = useState(false);
  const [useTmLiteMode, setUseTmLiteMode] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState('');
  const [hasSavedProgramSelection, setHasSavedProgramSelection] = useState(false);
  const [hasSignedContract, setHasSignedContract] = useState(false);
  const [candidateSignerEmail, setCandidateSignerEmail] = useState(initialSession && initialSession.email ? initialSession.email : '');
  const [candidateSignerName, setCandidateSignerName] = useState(initialSession && initialSession.name ? initialSession.name : '');
  const [isSavingProgramSelection, setIsSavingProgramSelection] = useState(false);
  const [programTouched, setProgramTouched] = useState(false);
  const [contractTouched, setContractTouched] = useState(false);
  const [visibleProgramFinalSteps, setVisibleProgramFinalSteps] = useState(0);
  const [programFinalStepStatuses, setProgramFinalStepStatuses] = useState(() => programFinalSteps.map(() => 'idle'));
  const [programFinalStepErrors, setProgramFinalStepErrors] = useState(() => programFinalSteps.map(() => ''));
  const [programFinalFailed, setProgramFinalFailed] = useState(false);
  const [showProgramFinalMessage, setShowProgramFinalMessage] = useState(false);
  const [skipProgramFinalProcessing, setSkipProgramFinalProcessing] = useState(false);
  const fotoRostroInputRef = useRef(null);
  const ineFrontInputRef = useRef(null);
  const ineBackInputRef = useRef(null);
  const caratulaInputRef = useRef(null);
  const csfInputRef = useRef(null);

  const recid = new URLSearchParams(window.location.search).get('recid');
  const debugMode = new URLSearchParams(window.location.search).get('debug') === 'true';
  const hasValidRecid = /^\d+$/.test(recid || '');

  const shouldShowSignedInError = isSignedIn;
  const hasActivePreRegistrationSession = !shouldShowSignedInError && !!preRegistrationSession;
  const shouldShowRecidError = !isSignedIn && !hasValidRecid && !hasActivePreRegistrationSession;
  const shouldShowContent = !shouldShowSignedInError && !shouldShowRecidError;
  const shouldForceThankYou = shouldShowContent && hasActivePreRegistrationSession && currentStep !== 7 && currentStep !== 8 && currentStep !== 9;
  const shouldShowStep1Form = shouldShowContent && !shouldForceThankYou && !showIntroOptions && currentStep === 1;
  const shouldShowStep1AccountLookup = shouldShowStep1Form && showAccountLookupScreen;
  const shouldShowStep2Form = shouldShowContent && !shouldForceThankYou && !showIntroOptions && currentStep === 2;
  const shouldShowStep3Form = shouldShowContent && !shouldForceThankYou && !showIntroOptions && currentStep === 3;
  const shouldShowCandidateSignInForm = shouldShowContent && !shouldForceThankYou && !showIntroOptions && currentStep === 6;
  const shouldShowPasswordForm = shouldShowContent && !shouldForceThankYou && !showIntroOptions && currentStep === 4;
  const shouldShowThankYou = shouldShowContent && (shouldForceThankYou || (!showIntroOptions && currentStep === 5));
  const shouldShowProfileUploadStep = shouldShowContent && !showIntroOptions && currentStep === 7;
  const shouldShowNextScreen = shouldShowContent && !showIntroOptions && currentStep === 8;
  const shouldShowProgramFinalScreen = shouldShowContent && !showIntroOptions && currentStep === 9;
  const shouldLoadCandidateData = hasActivePreRegistrationSession || shouldShowProfileUploadStep || shouldShowNextScreen;
  const shouldLimitProgramsToTmLite = csfStatus === 'noCSF' || useTmLiteMode;
  const shouldRequireManualRfc = csfStatus === 'Manual' || csfStatus === 'noCSF';
  const isClabeSaved = /^\d{18}$/.test(clabe) && clabe === confirmarClabe && clabe === savedClabeBancaria && savedClabeBancaria.length > 0;

  useEffect(() => {
    if (shouldShowContent && recid) {
      localStorage.setItem('preregistro_recid', recid);
    }
  }, [shouldShowContent, recid]);

  useEffect(() => {
    if (shouldForceThankYou) {
      setShowIntroOptions(false);
      setCurrentStep(5);
    }
  }, [shouldForceThankYou]);

  useEffect(() => {
    if (!shouldShowProgramFinalScreen) {
      setVisibleProgramFinalSteps(0);
      setProgramFinalStepStatuses(programFinalSteps.map(() => 'idle'));
      setProgramFinalStepErrors(programFinalSteps.map(() => ''));
      setProgramFinalFailed(false);
      setShowProgramFinalMessage(false);
      return undefined;
    }

    if (skipProgramFinalProcessing) {
      setVisibleProgramFinalSteps(0);
      setProgramFinalStepStatuses(programFinalSteps.map(() => 'idle'));
      setProgramFinalStepErrors(programFinalSteps.map(() => ''));
      setProgramFinalFailed(false);
      setShowProgramFinalMessage(true);
      return undefined;
    }

    let isCancelled = false;

    const setStepStatus = (stepIndex, status) => {
      setProgramFinalStepStatuses((prev) => prev.map((currentStatus, index) => (index === stepIndex ? status : currentStatus)));
    };

    const setStepError = (stepIndex, message) => {
      setProgramFinalStepErrors((prev) => prev.map((currentError, index) => (index === stepIndex ? message : currentError)));
    };

    const getCandidateFieldsOrThrow = async (candidateObjectId, fallbackMessage) => {
      if (!candidateObjectId) {
        throw new Error('No se encontró el identificador de la sesión. Por favor inicia sesión de nuevo.');
      }

      let response;
      try {
        response = await AuthService.getCandidate(candidateObjectId);
      } catch (error) {
        throw new Error(getApiErrorMessage(error, fallbackMessage));
      }

      const responseData = response && response.data;
      const candidateFields = responseData && responseData.candidateData;
      if (!responseData || responseData.success !== true || !candidateFields) {
        throw new Error((responseData && responseData.message) || fallbackMessage);
      }

      return candidateFields;
    };

    const runProgramFinalSteps = async () => {
      const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';

      const validateCandidateData = async () => {
        const candidateFields = await getCandidateFieldsOrThrow(candidateObjectId, 'No fue posible validar los datos del preregistro.');
        const csfStatusValue = candidateFields.csf_status || '';

        if (isMissingCandidateValue(recid)) {
          throw new Error('No se encontró el recid del preregistro.');
        }

        if ((csfStatusValue === 'Manual' || csfStatusValue === 'noCSF') && isMissingCandidateValue(candidateFields.manual_rfc)) {
          throw new Error('Falta el RFC manual para continuar.');
        }

        if (csfStatusValue === 'noCSF' && candidateFields.ingresoPromocion !== 'TM Lite') {
          throw new Error('Cuando csf_status es noCSF, el programa debe ser TM Lite.');
        }

        if (csfStatusValue !== 'noCSF' && isMissingCandidateValue(candidateFields.csf_url)) {
          throw new Error('Falta csf_url para continuar.');
        }

        if (csfStatusValue === 'Valid') {
          const validCsfRequiredFields = [
            'csf_url',
            'csf_CP',
            'csf_Calle',
            'csf_Colonia',
            'csf_Entidad',
            'csf_Fa_Name',
            'csf_Mo_Name',
            'csf_Municipio',
            'csf_Name',
            'csf_NumExt',
            'csf_Outputname',
            'csf_RFC',
          ];

          const missingValidCsfFields = validCsfRequiredFields.filter((fieldName) => isMissingCandidateValue(candidateFields[fieldName]));
          if (missingValidCsfFields.length > 0) {
            throw new Error(`Faltan campos CSF obligatorios: ${missingValidCsfFields.join(', ')}`);
          }
        }

        const requiredFields = [
          'accountEmail',
          'recid',
          's3_foto_rostro',
          's3_Signed_foto_rostro',
          's3_INE_anverso',
          's3_Signed_INE_anverso',
          's3_INE_reverso',
          's3_Signed_INE_reverso',
          's3_caratula_bancaria',
          's3_Signed_caratula_bancaria',
          'clabe_Bancaria',
          'ingresoPromocion',
          'nombres',
          'apellidos',
          'telefono',
          'curp',
          'estado',
          'ciudad',
          'codigoPostal',
          'colonia',
          'calle',
          'numeroExterior',
        ];

        const missingRequiredFields = requiredFields.filter((fieldName) => isMissingCandidateValue(candidateFields[fieldName]));
        if (missingRequiredFields.length > 0) {
          throw new Error(`Faltan campos obligatorios: ${missingRequiredFields.join(', ')}`);
        }

        if (candidateFields.outofdate !== false) {
          throw new Error('El campo outofdate debe ser false para continuar.');
        }
      };

      const reviewContract = async () => {
        const candidateFields = await getCandidateFieldsOrThrow(candidateObjectId, 'No fue posible revisar el contrato firmado.');
        if (isMissingCandidateValue(candidateFields.contractEsigURL)) {
          throw new Error('No se encontró firma del documento');
        }
      };

      const updateEshopAccount = async () => {
        if (!candidateObjectId) {
          throw new Error('No se encontró el identificador de la sesión. Por favor inicia sesión de nuevo.');
        }

        let updateEshopResponse;
        try {
          updateEshopResponse = await AuthService.updateEshopUser(candidateObjectId);
        } catch (error) {
          throw new Error(getApiErrorMessage(error, 'No fue posible actualizar la cuenta de eShop.'));
        }

        const updateEshopData = updateEshopResponse && updateEshopResponse.data;
        if (!updateEshopData || updateEshopData.success !== true) {
          throw new Error((updateEshopData && updateEshopData.message) || 'No fue posible actualizar la cuenta de eShop.');
        }
      };

      const sendInformation = async () => {
        if (!candidateObjectId) {
          throw new Error('No se encontró el identificador de la sesión. Por favor inicia sesión de nuevo.');
        }

        let preregisterResponse;
        try {
          preregisterResponse = await AuthService.preregisterToNS(candidateObjectId);
        } catch (error) {
          throw new Error(getApiErrorMessage(error, 'No fue posible enviar la información a preregisterToNS.'));
        }

        const preregisterData = preregisterResponse && preregisterResponse.data;
        if (!preregisterData || preregisterData.success !== true) {
          throw new Error((preregisterData && preregisterData.message) || 'Respuesta inválida del endpoint /users/preregisterToNS/.');
        }

        let updateStatusResponse;
        try {
          updateStatusResponse = await AuthService.updateCandidate({
            ObjectId: candidateObjectId,
            prereg_status: 'preregistered',
          });
        } catch (error) {
          throw new Error(getApiErrorMessage(error, 'No fue posible actualizar prereg_status.'));
        }

        const updateStatusData = updateStatusResponse && updateStatusResponse.data;
        if (!updateStatusData || updateStatusData.success !== true) {
          throw new Error((updateStatusData && updateStatusData.message) || 'No fue posible actualizar prereg_status.');
        }

        syncPreRegistrationSessionFromResponse(updateStatusData);
      };

      const stepRunners = [
        validateCandidateData,
        reviewContract,
        sendInformation,
        updateEshopAccount,
      ];

      for (let index = 0; index < stepRunners.length; index += 1) {
        if (isCancelled) {
          return;
        }

        setVisibleProgramFinalSteps((currentValue) => Math.max(currentValue, index + 1));
        setStepError(index, '');
        setStepStatus(index, 'running');

        let stepErrorMessage = '';
        const startedAt = Date.now();

        try {
          await stepRunners[index]();
        } catch (error) {
          stepErrorMessage = (error && error.message) || 'Ocurrió un error al procesar el paso.';
        }

        const elapsedMs = Date.now() - startedAt;
        const remainingMs = Math.max(programFinalStepMinDurationMs - elapsedMs, 0);
        if (remainingMs > 0) {
          await sleep(remainingMs);
        }

        if (isCancelled) {
          return;
        }

        if (stepErrorMessage) {
          setStepError(index, stepErrorMessage);
          setStepStatus(index, 'error');
          setProgramFinalFailed(true);
          setShowProgramFinalMessage(false);
          return;
        }

        setStepStatus(index, 'success');
      }

      if (!isCancelled) {
        await sleep(programFinalMessageDelayMs);
      }

      if (!isCancelled) {
        setProgramFinalFailed(false);
        setShowProgramFinalMessage(true);
      }
    };

    runProgramFinalSteps();

    return () => {
      isCancelled = true;
    };
  }, [shouldShowProgramFinalScreen, recid, skipProgramFinalProcessing]);

  useEffect(() => {
    if (shouldShowSignedInError) {
      clearPreRegistrationSession();
      setPreRegistrationSession(null);
      setIsSessionRedirect(false);
    }
  }, [shouldShowSignedInError]);

  useEffect(() => {
    if (!shouldShowContent || shouldShowSignedInError) {
      return;
    }

    if (!hasActivePreRegistrationSigning()) {
      return;
    }

    if (!getActivePreRegistrationSession()) {
      return;
    }

    clearPreRegistrationSigning();
    setShowIntroOptions(false);
    setCurrentStep(8);
  }, [shouldShowContent, shouldShowSignedInError]);

  useEffect(() => {
    logPreRegistrationStorage('page-load');
  }, []);

  useEffect(() => {
    if (!shouldLoadCandidateData) {
      return;
    }

    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';
    if (!candidateObjectId) {
      return;
    }

    let isCancelled = false;

    AuthService.getCandidate(candidateObjectId)
      .then((response) => {
        if (isCancelled) {
          return;
        }

        const responseData = response && response.data;
        if (!responseData || responseData.success !== true) {
          return;
        }

        // Candidate fields come nested under candidateData, not at the response root.
        const candidateFields = responseData.candidateData || {};

        syncPreRegistrationSessionFromResponse({
          ObjectId: responseData.ObjectId,
          accountEmail: candidateFields.accountEmail,
          curp: candidateFields.curp,
          CandidateName: [candidateFields.nombres, candidateFields.apellidos].filter(Boolean).join(' ').trim(),
        });
        setAccountEmail(candidateFields.accountEmail || '');
        setCandidateSignerEmail(candidateFields.accountEmail || '');
        setCandidateSignerName(resolveContractSignerName(candidateFields));

        setHasUploadedFotoRostro(!!candidateFields.s3_foto_rostro);
        setHasUploadedIneFront(!!candidateFields.s3_INE_anverso);
        setHasUploadedIneBack(!!candidateFields.s3_INE_reverso);
        setHasUploadedCaratula(!!candidateFields.s3_caratula_bancaria);

        if (candidateFields.clabe_Bancaria) {
          setClabe(candidateFields.clabe_Bancaria);
          setConfirmarClabe(candidateFields.clabe_Bancaria);
          setSavedClabeBancaria(candidateFields.clabe_Bancaria);
        }
        if (!isMissingCandidateValue(candidateFields.banco)) {
          setBanco(String(candidateFields.banco));
          setHasSavedBanco(true);
        } else {
          setBanco('');
          setHasSavedBanco(false);
        }

        const backendCsfStatus = candidateFields.csf_status || '';
        setCsfStatus(backendCsfStatus);
        setHasUploadedCsf(backendCsfStatus === 'Valid');
        setHasRequestedManualCsfReview(backendCsfStatus === 'Manual');
        setUseTmLiteMode(backendCsfStatus === 'noCSF');

        if (candidateFields.manual_rfc) {
          setManualRfc(normalizeManualRfc(candidateFields.manual_rfc));
        }

        const isPreRegistered = candidateFields.prereg_status === 'preregistered';
        if (isPreRegistered) {
          setSkipProgramFinalProcessing(true);
          setShowIntroOptions(false);
          setCurrentStep(9);
        } else {
          setSkipProgramFinalProcessing(false);
        }

        if (candidateFields.ingresoPromocion === 'Gana tu TM') {
          setSelectedProgram('GANA_TU_THERMOMIX');
          setHasSavedProgramSelection(true);
        } else if (candidateFields.ingresoPromocion === 'TM sin Barreras') {
          setSelectedProgram('TM_SIN_BARRERAS');
          setHasSavedProgramSelection(true);
        } else if (candidateFields.ingresoPromocion === 'TM Elite') {
          setSelectedProgram('TM_ELITE');
          setHasSavedProgramSelection(true);
        } else if (candidateFields.ingresoPromocion === 'TM Lite') {
          setSelectedProgram('TM_LITE');
          setHasSavedProgramSelection(true);
        } else {
          setSelectedProgram('');
          setHasSavedProgramSelection(false);
        }

        setHasSignedContract(!!candidateFields.contractEsigURL);
      })
      .catch((error) => {
        console.log('[getCandidate error]', error);
      });

    return () => {
      isCancelled = true;
    };
  }, [shouldLoadCandidateData]);

  const getIngresoPromocionValue = (programOption) => {
    if (programOption === 'GANA_TU_THERMOMIX') {
      return 'Gana tu TM';
    }
    if (programOption === 'TM_SIN_BARRERAS') {
      return 'TM sin Barreras';
    }
    if (programOption === 'TM_ELITE') {
      return 'TM Elite';
    }
    if (programOption === 'TM_LITE') {
      return 'TM Lite';
    }
    return '';
  };

  useEffect(() => {
    if (!shouldLimitProgramsToTmLite) {
      return;
    }

    if (selectedProgram && selectedProgram !== 'TM_LITE') {
      setSelectedProgram('');
      setHasSavedProgramSelection(false);
    }
  }, [selectedProgram, shouldLimitProgramsToTmLite]);

  const handleProgramSelectionChange = async (event) => {
    const newSelection = event && event.target ? event.target.value : '';
    const ingresoPromocion = getIngresoPromocionValue(newSelection);
    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';

    setSelectedProgram(newSelection);
    setHasSavedProgramSelection(false);
    setProgramTouched(false);

    if (!candidateObjectId) {
      return;
    }

    try {
      setIsSavingProgramSelection(true);
      const updateResponse = await AuthService.updateCandidate({
        ObjectId: candidateObjectId,
        ingresoPromocion,
      });
      const updateData = updateResponse && updateResponse.data;

      if (updateData && updateData.success === true) {
        syncPreRegistrationSessionFromResponse(updateData);
        if (ingresoPromocion) {
          setHasSavedProgramSelection(true);
        }
      }
    } finally {
      setIsSavingProgramSelection(false);
    }
  };

  const handleProgramNext = () => {
    setProgramTouched(true);
    setContractTouched(true);

    if (!hasSavedProgramSelection || !hasSignedContract) {
      return;
    }

    setSkipProgramFinalProcessing(false);
    setCurrentStep(9);
  };

  const handleSignContract = () => {
    const expiresAt = Date.now() + preRegSigningTTLms;
    const signerMail = candidateSignerEmail || accountEmail || (preRegistrationSession && preRegistrationSession.email) || '';
    const fallbackName = (preRegistrationSession && preRegistrationSession.name) || [formData.nombres, formData.apellidos].filter(Boolean).join(' ').trim();
    const signerName = candidateSignerName || fallbackName;
    const ingresoPromocion = getIngresoPromocionValue(selectedProgram);
    const docType = ingresoPromocion === 'TM Lite' || shouldLimitProgramsToTmLite ? 'convenio' : 'contrato';
    const queryParams = new URLSearchParams({
      SignerMail: encodeBase64Value(signerMail),
      SignerName: encodeBase64Value(signerName),
      DocType: encodeBase64Value(docType),
    });

    localStorage.setItem(preRegSigningKey, 'true');
    localStorage.setItem(preRegSigningExpiresKey, String(expiresAt));
    window.location.href = `${shopBaseUrl}/esignaturelanding/?${queryParams.toString()}`;
  };

  const isCurpValid = useMemo(() => curpRegex.test(formData.curp), [formData.curp]);

  const step1Validation = useMemo(() => {
    const errors = {
      nombres: formData.nombres.trim().length === 0 ? 'Ingresa tu nombre.' : '',
      apellidos: formData.apellidos.trim().length === 0 ? 'Ingresa tus apellidos.' : '',
      telefono: /^\d{10}$/.test(formData.telefono) ? '' : 'Ingresa un teléfono válido de 10 dígitos.',
      curp: showAccountLookupScreen ? '' : (formData.curp.trim().length === 0
        ? 'Ingresa tu CURP.'
        : (isCurpValid ? '' : curpInvalidMsg)),
      tieneThermomix: formData.tieneThermomix.length === 0 ? 'Selecciona una opción de Thermomix.' : '',
      vioDemo: formData.vioDemo.length === 0 ? 'Selecciona si has visto una demostración.' : '',
      haVendido: formData.haVendido.length === 0 ? 'Selecciona si has vendido algún producto antes.' : '',
      cualVendio: formData.haVendido === 'SI' && formData.cualVendio.trim().length === 0 ? 'Especifica qué producto has vendido.' : '',
    };

    const isValid = Object.values(errors).every((msg) => msg.length === 0);
    return { errors, isValid };
  }, [formData, isCurpValid, showAccountLookupScreen]);

  const isStep3EmailValid = useMemo(() => emailRegex.test(accountEmail), [accountEmail]);
  const canProceedStep3 = isStep3EmailValid && acceptedPrivacy;
  const isCandidateSignInEmailValid = useMemo(() => emailRegex.test(candidateSignInData.email), [candidateSignInData.email]);

  const step2Validation = useMemo(() => {
    const errors = {
      descripcion: formStep2Data.descripcion.trim().length === 0 ? 'Describe brevemente tus intereses.' : '',
      codigoPostal: /^\d{5}$/.test(formStep2Data.codigoPostal) ? '' : 'Ingresa un código postal válido de 5 dígitos.',
      estado: formStep2Data.estado.trim().length === 0 ? 'Selecciona tu estado.' : '',
      ciudad: formStep2Data.ciudad.trim().length === 0 ? 'Ingresa tu ciudad o municipio.' : '',
      colonia: formStep2Data.colonia.trim().length === 0 ? 'Ingresa tu colonia.' : '',
      calle: formStep2Data.calle.trim().length === 0 ? 'Ingresa tu calle.' : '',
      numeroExterior: formStep2Data.numeroExterior.trim().length === 0 ? 'Ingresa el número exterior.' : '',
      numeroInterior: '',
      horarioDisponible: formStep2Data.horarioDisponible.length === 0 ? 'Selecciona un horario disponible.' : '',
    };

    const isValid = Object.values(errors).every((msg) => msg.length === 0);
    return { errors, isValid };
  }, [formStep2Data]);

  const isPasswordSecure = useMemo(() => securePasswordRegex.test(passwordData.password), [passwordData.password]);
  const isPasswordMatch = useMemo(() => {
    if (passwordData.confirmPassword.length === 0) {
      return false;
    }
    return passwordData.password === passwordData.confirmPassword;
  }, [passwordData.password, passwordData.confirmPassword]);

  const goHome = () => {
    window.location.href = '/';
  };

  const signOutAndGoHome = () => {
    AuthService.logout();
    window.location.href = '/';
  };

  const handleClosePreRegistrationSession = () => {
    clearPreRegistrationSession();
    window.location.reload();
  };

  const normalizeName = (value) => {
    const base = value
      .replace(/["']/g, '')
      .replace(/[ñÑ]/g, '[[ENYE]]')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\[\[ENYE\]\]/g, 'Ñ');
    return base.toUpperCase().replace(/[^A-ZÑ ]/g, '');
  };

  const normalizePhone = (value) => {
    return value.replace(/["']/g, '').replace(/\D/g, '').slice(0, 10);
  };

  const normalizeCurp = (value) => {
    return value.replace(/["']/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 18);
  };

  const normalizeFreeText = (value) => {
    return value.replace(/["']/g, '').slice(0, 60);
  };

  const normalizeEmail = (value) => {
    return value.replace(/["']/g, '').trim().toLowerCase().slice(0, 120);
  };

  const normalizeDescription = (value) => {
    return value.replace(/["']/g, '').slice(0, 220);
  };

  const normalizeZipCode = (value) => {
    return value.replace(/["']/g, '').replace(/\D/g, '').slice(0, 5);
  };

  const normalizeAddressText = (value) => {
    return value.replace(/["']/g, '').slice(0, 80);
  };

  const normalizeManualRfc = (value) => {
    return value.replace(/["']/g, '').toUpperCase().replace(/[^A-Z0-9Ñ&]/g, '').slice(0, 13);
  };

  const sanitizePasswordValue = (value) => {
    // Keep special characters but block quote characters, backslash and control chars.
    const withoutQuotes = value.replace(/["'\\]/g, '');
    return Array.from(withoutQuotes)
      .filter((ch) => {
        const code = ch.charCodeAt(0);
        return code >= 32 && code !== 127;
      })
      .join('');
  };

  const resolveObjectIdFromResponse = (responseData) => {
    return (responseData && responseData.ObjectId) || '';
  };

  const syncPreRegistrationSessionFromResponse = (responseData, fallback = {}) => {
    const activeSession = getActivePreRegistrationSession() || {};
    const resolvedUser = (responseData && responseData.accountEmail) || fallback.user || activeSession.user || '';
    const resolvedEmail = (responseData && responseData.accountEmail) || fallback.email || activeSession.email || resolvedUser || '';
    const resolvedCurp = (responseData && responseData.curp) || fallback.curp || activeSession.curp || '';
    const resolvedName = (responseData && responseData.CandidateName) || fallback.name || activeSession.name || '';
    const resolvedObjectId = resolveObjectIdFromResponse(responseData) || fallback.ObjectId || activeSession.ObjectId || '';

    if (!resolvedUser || !resolvedEmail || !resolvedCurp || !resolvedName) {
      return;
    }

    persistPreRegistrationSession({
      user: resolvedUser,
      email: resolvedEmail,
      curp: resolvedCurp,
      name: resolvedName,
      ObjectId: resolvedObjectId,
    });
    setPreRegistrationSession(getActivePreRegistrationSession());
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleToggle = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === 'haVendido' && value === 'NO' ? { cualVendio: '' } : {}),
    }));
  };

  const handleStep2InputChange = (field, value) => {
    setFormStep2Data((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const resetLookupFlow = () => {
    clearPreRegistrationLookup();
    setAccountLookupError('');
    setAccountLookupSuccess('');
    setAccountLookupResult(null);
    setCandidateSignInData((prev) => ({
      ...prev,
      email: '',
    }));
  };

  const clearSubAccountSessionStorage = () => {
    clearPreRegistrationSession();
    clearPreRegistrationSigning();
    setPreRegistrationSession(null);
    setIsSessionRedirect(false);
    setCandidateSignerEmail('');
    setCandidateSignerName('');
  };

  const storeLookupResult = (searchData, lookupType) => {
    localStorage.setItem(preRegLookupKeys.result, JSON.stringify(searchData));
    localStorage.setItem(preRegLookupKeys.type, lookupType);
  };

  const handleAccountLookupSearch = async () => {
    const rawValue = candidateSignInData.email || '';
    const trimmedValue = rawValue.trim();
    const uppercaseValue = trimmedValue.toUpperCase();
    const lowercaseValue = trimmedValue.toLowerCase();

    setAccountLookupError('');
    setAccountLookupSuccess('');
    setAccountLookupResult(null);

    let lookupPayload = null;
    let lookupType = '';

    if (emailRegex.test(lowercaseValue)) {
      lookupPayload = {
        type: 'login',
        email: lowercaseValue,
      };
      lookupType = 'email';
    } else if (curpRegex.test(uppercaseValue)) {
      lookupPayload = {
        type: 'login',
        custentity_curp: uppercaseValue,
      };
      lookupType = 'curp';
    } else if (manualRfcRegex.test(uppercaseValue)) {
      lookupPayload = {
        type: 'login',
        rfc: uppercaseValue,
      };
      lookupType = 'rfc';
    }

    if (!lookupPayload) {
      setAccountLookupError('Valor inválido.');
      return;
    }

    try {
      setIsSearchingAccountLookup(true);
      const searchResponse = await AuthService.searchRep(lookupPayload);
      const searchData = searchResponse && searchResponse.data;

      if (searchData && searchData.success === true) {
        setAccountLookupResult(searchData);
        storeLookupResult(searchData, lookupType);
        if (lookupType === 'email') {
          setAccountLookupSuccess(`Registro encontrado: "${searchData.curp || ''}"`);
          setAccountLookupError('');
        } else {
          setAccountLookupSuccess(`Registro encontrado: "${maskEmailForDisplay(searchData.email || '')}"`);
        }
        return;
      }

      const searchMessage = String((searchData && searchData.message) || '').trim().toLowerCase();
      if (searchMessage.includes('existing candidate')) {
        setAccountLookupError(renderExistingCandidateInlineMessage());
        return;
      }
      setAccountLookupError((searchData && searchData.message) || 'No se encontró la cuenta.');
    } catch (error) {
      const backendMessage = String((error && error.response && error.response.data && error.response.data.message) || '').trim();
      if (backendMessage.toLowerCase().includes('existing candidate')) {
        setAccountLookupError(renderExistingCandidateInlineMessage());
        return;
      }
      setAccountLookupError(backendMessage || 'No se pudo consultar la cuenta.');
    } finally {
      setIsSearchingAccountLookup(false);
    }
  };

  const handlePasswordChange = (field, value) => {
    setPasswordData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const goToSignInFromExistingCandidate = () => {
    localStorage.clear();
    clearPreRegistrationLookup();
    clearPreRegistrationSigning();
    clearPreRegistrationSession();
    setShowAccountLookupScreen(false);
    setAccountLookupError('');
    setAccountLookupSuccess('');
    setAccountLookupResult(null);
    setCurpValidationError('');
    setMailValidationError('');
    setCandidateSignInData({
      email: '',
      password: '',
    });
    setCandidateSignInTouched(false);
    setCandidateSignInError('');
    // Same target screen as the "Me registré hace menos de 30 días" option in step 1.
    setCurrentStep(6);
    setShowIntroOptions(false);
  };

  const renderExistingCandidateInlineMessage = () => (
    <span>
      Ya existe un Pre-registro en curso con este Mail/CURP/RFC{' '}
      <button
        type="button"
        onClick={goToSignInFromExistingCandidate}
        style={{
          color: '#1e9f66',
          background: 'transparent',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          textDecoration: 'underline',
          fontWeight: 600,
        }}
      >
        Inicia sesión para continuar
      </button>
    </span>
  );

  const validateCurpForNewRegistration = async (curpValue) => {
    const upperCurp = (curpValue || '').trim().toUpperCase();
    if (!upperCurp || !curpRegex.test(upperCurp)) {
      return true;
    }

    try {
      setIsValidatingCurp(true);
      const response = await AuthService.validateNewRep({
        type: 'login',
        custentity_curp: upperCurp,
      });

      const responseData = response && response.data;
      const backendMessage = String((responseData && responseData.message) || '').trim().toLowerCase();
      if (backendMessage.includes('existing candidate')) {
        setCurpValidationError(renderExistingCandidateInlineMessage());
        return false;
      }

      if (response && response.status === 200) {
        if (responseData && responseData.success === true) {
          setCurpValidationError('');
          return true;
        }

        setCurpValidationError('CURP duplicado, seleccione reingreso o valide sus datos.');
        return false;
      }

      setCurpValidationError('Error: No podemos validar el CURP en este momento, por favor intenta más tarde.');
      return false;
    } catch (error) {
      const backendMessage = String((error && error.response && error.response.data && error.response.data.message) || '').trim().toLowerCase();
      if (backendMessage.includes('existing candidate')) {
        setCurpValidationError(renderExistingCandidateInlineMessage());
        return false;
      }
      setCurpValidationError('Error: No podemos validar el CURP en este momento, por favor intenta más tarde.');
      return false;
    } finally {
      setIsValidatingCurp(false);
    }
  };

  const validateMailForNewRegistration = async (mailValue) => {
    const normalizedMail = (mailValue || '').trim().toLowerCase();
    if (!normalizedMail || !emailRegex.test(normalizedMail)) {
      return true;
    }

    try {
      setIsValidatingMail(true);
      const response = await AuthService.validateNewRep({
        type: 'login',
        email: normalizedMail,
      });

      const responseData = response && response.data;
      const backendMessage = String((responseData && responseData.message) || '').trim().toLowerCase();
      if (backendMessage.includes('existing candidate')) {
        setMailValidationError(renderExistingCandidateInlineMessage());
        return false;
      }

      if (response && response.status === 200) {
        if (responseData && responseData.success === true) {
          setMailValidationError('');
          return true;
        }

        setMailValidationError('Mail duplicado, seleccione reingreso o valide sus datos.');
        return false;
      }

      setMailValidationError('Error: No podemos validar el Mail en este momento, por favor intenta más tarde.');
      return false;
    } catch (error) {
      const backendMessage = String((error && error.response && error.response.data && error.response.data.message) || '').trim().toLowerCase();
      if (backendMessage.includes('existing candidate')) {
        setMailValidationError(renderExistingCandidateInlineMessage());
        return false;
      }
      setMailValidationError('Error: No podemos validar el Mail en este momento, por favor intenta más tarde.');
      return false;
    } finally {
      setIsValidatingMail(false);
    }
  };

  const handleSubmit = async () => {
    setStep1Touched(true);

    if (showAccountLookupScreen && (!accountLookupResult || !accountLookupSuccess)) {
      setAccountLookupError('Para reingresos debes buscar tu cuenta.');
      return;
    }

    if (!showAccountLookupScreen) {
      const upperCurp = (formData.curp || '').trim().toUpperCase();
      if (upperCurp && curpRegex.test(upperCurp)) {
        const isCurpAllowed = await validateCurpForNewRegistration(upperCurp);
        if (!isCurpAllowed) {
          return;
        }
      }
    }

    if (!step1Validation.isValid) {
      return;
    }

    setCurrentStep(2);
  };

  const handleStep2Submit = () => {
    setStep2Touched(true);
    if (!step2Validation.isValid) {
      return;
    }

    setCurrentStep(3);
  };

  const handleStep3Submit = async () => {
    setStep3Touched(true);

    if (showAccountLookupScreen && accountLookupResult) {
      const currentValue = (accountEmail || '').trim().toLowerCase();
      const resultEmail = (accountLookupResult.email || '').trim().toLowerCase();

      if (!currentValue || currentValue !== resultEmail) {
        setSubmitCandidateError('El Mail no concide con el de registro anterior');
        return;
      }
    }

    if (!showAccountLookupScreen && accountEmail) {
      const isMailValid = await validateMailForNewRegistration(accountEmail);
      if (!isMailValid) {
        return;
      }
    }

    if (!canProceedStep3) {
      return;
    }

    if (showAccountLookupScreen && accountLookupResult) {
      try {
        setIsValidatingReingresoEmail(true);
        const dCandBLResponse = await AuthService.validateDCandBL(accountEmail);
        const dCandBLData = dCandBLResponse && dCandBLResponse.data;

        if (!dCandBLData || dCandBLData.success !== true || dCandBLData.valid !== true) {
          setSubmitCandidateError((dCandBLData && dCandBLData.message) || 'No fue posible validar el correo en este momento.');
          return;
        }
      } catch (error) {
        setSubmitCandidateError(getApiErrorMessage(error, 'No fue posible validar el correo en este momento.'));
        return;
      } finally {
        setIsValidatingReingresoEmail(false);
      }
    }

    setSubmitCandidateError('');
    setCurrentStep(4);
  };

  const handleCandidateSignInSubmit = async () => {
    setCandidateSignInTouched(true);
    setCandidateSignInError('');

    if (!isCandidateSignInEmailValid || candidateSignInData.password.length === 0) {
      return;
    }

    try {
      setIsCandidateSigningIn(true);
      const response = await AuthService.loginCandidate(candidateSignInData.email, candidateSignInData.password);
      const responseData = response && response.data;

      if (responseData && responseData.success === true) {
        console.log('[CandidateSignIn response]', responseData);
        syncPreRegistrationSessionFromResponse(responseData, {
          user: candidateSignInData.email,
          email: candidateSignInData.email,
          curp: '',
          name: '',
          ObjectId: '',
        });
        logPreRegistrationStorage('candidate-sign-in-success');
        setIsSessionRedirect(false);
        setCurrentStep(5);
        return;
      }

      setCandidateSignInError((responseData && responseData.message) || 'No fue posible iniciar sesión.');
    } catch (error) {
      const backendMessage = error && error.response && error.response.data && error.response.data.message;
      setCandidateSignInError(backendMessage || 'No fue posible iniciar sesión.');
    } finally {
      setIsCandidateSigningIn(false);
    }
  };

  const handleCreateAccount = async () => {
    setPasswordTouched(true);
    setSubmitCandidateError('');
    if (!isPasswordSecure || !isPasswordMatch) {
      return;
    }

    const isReingresoFlow = showAccountLookupScreen && !!accountLookupResult;
    const resolvedCurp = isReingresoFlow ? (accountLookupResult.curp || formData.curp) : formData.curp;

    const stepPayload = {
      ...formData,
      ...formStep2Data,
      accountEmail,
      curp: resolvedCurp,
      reingreso: isReingresoFlow,
      passwordPlain: passwordData.password,
      recid,
    };

    const payloadJson = JSON.stringify(stepPayload, null, 2);

    try {
      setIsSubmittingCandidate(true);
      const response = await AuthService.addCandidate(stepPayload);
      const responseData = response && response.data;

      if (responseData && responseData.success === true) {
        syncPreRegistrationSessionFromResponse(responseData, {
          user: accountEmail,
          email: accountEmail,
          curp: resolvedCurp,
          name: formData.nombres,
          ObjectId: responseData.ObjectId || '',
        });
        logPreRegistrationStorage('create-account-success');

        if (debugMode) {
          await copyTextToClipboard(payloadJson);
          window.alert('JSON copiado al portapapeles.');
        }

        setIsSessionRedirect(false);
        setCurrentStep(5);
        return;
      }

      setSubmitCandidateError((response && response.data && response.data.message) || 'No fue posible guardar el preregistro.');
    } catch (error) {
      const backendMessage = error && error.response && error.response.data && error.response.data.message;
      setSubmitCandidateError(backendMessage || 'No fue posible guardar el preregistro.');
    } finally {
      setIsSubmittingCandidate(false);
    }
  };

  const isAllowedFileType = (file) => {
    if (!file) {
      return false;
    }

    const mimeType = (file.type || '').toLowerCase();
    if (allowedUploadMimeTypes.includes(mimeType)) {
      return true;
    }

    const fileName = (file.name || '').toLowerCase();
    const extension = fileName.includes('.') ? fileName.split('.').pop() : '';
    return allowedUploadExtensions.includes(extension || '');
  };

  const handleOpenIneFrontSelector = () => {
    if (isUploadingIneFront) {
      return;
    }

    setUploadIneFrontError('');
    if (ineFrontInputRef.current) {
      ineFrontInputRef.current.value = '';
      ineFrontInputRef.current.click();
    }
  };

  const handleOpenFotoRostroSelector = () => {
    if (isUploadingFotoRostro) {
      return;
    }

    setUploadFotoRostroError('');
    if (fotoRostroInputRef.current) {
      fotoRostroInputRef.current.value = '';
      fotoRostroInputRef.current.click();
    }
  };

  const handleOpenIneBackSelector = () => {
    if (isUploadingIneBack) {
      return;
    }

    setUploadIneBackError('');
    if (ineBackInputRef.current) {
      ineBackInputRef.current.value = '';
      ineBackInputRef.current.click();
    }
  };

  const handleOpenCsfSelector = () => {
    if (isUploadingCsf) {
      return;
    }

    const wasManualMode = csfStatus === 'Manual';
    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';

    setUploadCsfError('');
    setShowCsfManualReviewHint(false);
    setHasRequestedManualCsfReview(false);
    if (wasManualMode) {
      setCsfStatus('');
      setManualRfc('');
      setManualRfcTouched(false);

      if (candidateObjectId) {
        AuthService.updateCandidate({
          ObjectId: candidateObjectId,
          csf_status: '',
          manual_rfc: '',
        }).then((updateResponse) => {
          const updateData = updateResponse && updateResponse.data;
          if (updateData && updateData.success === true) {
            syncPreRegistrationSessionFromResponse(updateData);
          }
        });
      }
    }
    if (csfInputRef.current) {
      csfInputRef.current.value = '';
      csfInputRef.current.click();
    }
  };

  const handleIneFrontFileChange = async (event) => {
    const file = event && event.target && event.target.files && event.target.files[0];
    setUploadIneFrontError('');

    if (!file) {
      return;
    }

    if (!isAllowedFileType(file)) {
      setHasUploadedIneFront(false);
      setUploadIneFrontError('Formato inválido. Solo se permiten JPG, PNG, TIFF o PDF.');
      return;
    }

    if (file.size > maxUploadSizeBytes) {
      setHasUploadedIneFront(false);
      setUploadIneFrontError('El archivo supera el máximo permitido de 10 MB.');
      return;
    }

    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';
    if (!candidateObjectId) {
      setHasUploadedIneFront(false);
      setUploadIneFrontError('No se encontró el identificador de la sesión. Por favor inicia sesión de nuevo.');
      return;
    }

    try {
      setIsUploadingIneFront(true);

      // Step 1: upload file to S3 Lambda
      const uploadResponse = await AuthService.uploadCandidateDocument('INEanverso', file);
      const s3Location = uploadResponse &&
        uploadResponse.data &&
        uploadResponse.data.uploaded &&
        uploadResponse.data.uploaded[0] &&
        uploadResponse.data.uploaded[0].location;
      const s3DownloadUrl = uploadResponse &&
        uploadResponse.data &&
        uploadResponse.data.uploaded &&
        uploadResponse.data.uploaded[0] &&
        uploadResponse.data.uploaded[0].downloadUrl;

      if (!s3Location || !s3DownloadUrl) {
        setHasUploadedIneFront(false);
        setUploadIneFrontError('La respuesta del servidor de archivos no contiene la ubicación del documento.');
        return;
      }

      // Step 2: persist document URLs in backend
      const updateResponse = await AuthService.updateCandidate({
        ObjectId: candidateObjectId,
        s3_INE_anverso: s3Location,
        s3_Signed_INE_anverso: s3DownloadUrl,
      });
      const updateData = updateResponse && updateResponse.data;

      if (debugMode) {
        await copyTextToClipboard(JSON.stringify(updateData || {}, null, 2));
        window.alert('Respuesta de CandidateUpdate copiada al portapapeles.');
      }

      if (updateData && updateData.success === true) {
        syncPreRegistrationSessionFromResponse(updateData);
        setHasUploadedIneFront(true);
        return;
      }

      setHasUploadedIneFront(false);
      setUploadIneFrontError((updateData && updateData.message) || 'El servidor no pudo actualizar el documento del candidato.');
    } catch (error) {
      setHasUploadedIneFront(false);
      const backendMessage = error && error.response && error.response.data && error.response.data.message;
      setUploadIneFrontError(backendMessage || 'No fue posible cargar el archivo. Inténtalo de nuevo.');
      if (debugMode) {
        const debugPayload = {
          errorMessage: error && error.message,
          status: error && error.response && error.response.status,
          data: error && error.response && error.response.data,
        };
        copyTextToClipboard(JSON.stringify(debugPayload, null, 2));
        window.alert('Error capturado. Detalles copiados al portapapeles.');
      }
    } finally {
      setIsUploadingIneFront(false);
    }
  };

  const handleFotoRostroFileChange = async (event) => {
    const file = event && event.target && event.target.files && event.target.files[0];
    setUploadFotoRostroError('');

    if (!file) {
      return;
    }

    if (!isAllowedFileType(file)) {
      setHasUploadedFotoRostro(false);
      setUploadFotoRostroError('Formato inválido. Solo se permiten JPG, PNG, TIFF o PDF.');
      return;
    }

    if (file.size > maxUploadSizeBytes) {
      setHasUploadedFotoRostro(false);
      setUploadFotoRostroError('El archivo supera el máximo permitido de 10 MB.');
      return;
    }

    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';
    if (!candidateObjectId) {
      setHasUploadedFotoRostro(false);
      setUploadFotoRostroError('No se encontró el identificador de la sesión. Por favor inicia sesión de nuevo.');
      return;
    }

    try {
      setIsUploadingFotoRostro(true);

      const uploadResponse = await AuthService.uploadCandidateDocument('fotoRostro', file);
      const s3Location = uploadResponse && uploadResponse.data && uploadResponse.data.uploaded && uploadResponse.data.uploaded[0] && uploadResponse.data.uploaded[0].location;
      const s3DownloadUrl = uploadResponse && uploadResponse.data && uploadResponse.data.uploaded && uploadResponse.data.uploaded[0] && uploadResponse.data.uploaded[0].downloadUrl;

      if (!s3Location || !s3DownloadUrl) {
        setHasUploadedFotoRostro(false);
        setUploadFotoRostroError('La respuesta del servidor de archivos no contiene la ubicación del documento.');
        return;
      }

      const updateResponse = await AuthService.updateCandidate({
        ObjectId: candidateObjectId,
        s3_foto_rostro: s3Location,
        s3_Signed_foto_rostro: s3DownloadUrl,
      });
      const updateData = updateResponse && updateResponse.data;

      if (debugMode) {
        await copyTextToClipboard(JSON.stringify(updateData || {}, null, 2));
        window.alert('Respuesta de CandidateUpdate copiada al portapapeles.');
      }

      if (updateData && updateData.success === true) {
        syncPreRegistrationSessionFromResponse(updateData);
        setHasUploadedFotoRostro(true);
        return;
      }

      setHasUploadedFotoRostro(false);
      setUploadFotoRostroError((updateData && updateData.message) || 'El servidor no pudo actualizar el documento del candidato.');
    } catch (error) {
      setHasUploadedFotoRostro(false);
      const backendMessage = error && error.response && error.response.data && error.response.data.message;
      setUploadFotoRostroError(backendMessage || 'No fue posible cargar el archivo. Inténtalo de nuevo.');
      if (debugMode) {
        const debugPayload = {
          errorMessage: error && error.message,
          status: error && error.response && error.response.status,
          data: error && error.response && error.response.data,
        };
        copyTextToClipboard(JSON.stringify(debugPayload, null, 2));
        window.alert('Error capturado. Detalles copiados al portapapeles.');
      }
    } finally {
      setIsUploadingFotoRostro(false);
    }
  };

  const handleIneBackFileChange = async (event) => {
    const file = event && event.target && event.target.files && event.target.files[0];
    setUploadIneBackError('');

    if (!file) {
      return;
    }

    if (!isAllowedFileType(file)) {
      setHasUploadedIneBack(false);
      setUploadIneBackError('Formato inválido. Solo se permiten JPG, PNG, TIFF o PDF.');
      return;
    }

    if (file.size > maxUploadSizeBytes) {
      setHasUploadedIneBack(false);
      setUploadIneBackError('El archivo supera el máximo permitido de 10 MB.');
      return;
    }

    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';
    if (!candidateObjectId) {
      setHasUploadedIneBack(false);
      setUploadIneBackError('No se encontró el identificador de la sesión. Por favor inicia sesión de nuevo.');
      return;
    }

    try {
      setIsUploadingIneBack(true);

      // Step 1: upload file to S3 Lambda
      const uploadResponse = await AuthService.uploadCandidateDocument('INEreverso', file);
      const s3Location = uploadResponse &&
        uploadResponse.data &&
        uploadResponse.data.uploaded &&
        uploadResponse.data.uploaded[0] &&
        uploadResponse.data.uploaded[0].location;
      const s3DownloadUrl = uploadResponse &&
        uploadResponse.data &&
        uploadResponse.data.uploaded &&
        uploadResponse.data.uploaded[0] &&
        uploadResponse.data.uploaded[0].downloadUrl;

      if (!s3Location || !s3DownloadUrl) {
        setHasUploadedIneBack(false);
        setUploadIneBackError('La respuesta del servidor de archivos no contiene la ubicación del documento.');
        return;
      }

      // Step 2: persist document URLs in backend
      const updateResponse = await AuthService.updateCandidate({
        ObjectId: candidateObjectId,
        s3_INE_reverso: s3Location,
        s3_Signed_INE_reverso: s3DownloadUrl,
      });
      const updateData = updateResponse && updateResponse.data;

      if (debugMode) {
        await copyTextToClipboard(JSON.stringify(updateData || {}, null, 2));
        window.alert('Respuesta de CandidateUpdate copiada al portapapeles.');
      }

      if (updateData && updateData.success === true) {
        syncPreRegistrationSessionFromResponse(updateData);
        setHasUploadedIneBack(true);
        return;
      }

      setHasUploadedIneBack(false);
      setUploadIneBackError((updateData && updateData.message) || 'El servidor no pudo actualizar el documento del candidato.');
    } catch (error) {
      setHasUploadedIneBack(false);
      const backendMessage = error && error.response && error.response.data && error.response.data.message;
      setUploadIneBackError(backendMessage || 'No fue posible cargar el archivo. Inténtalo de nuevo.');
      if (debugMode) {
        const debugPayload = {
          errorMessage: error && error.message,
          status: error && error.response && error.response.status,
          data: error && error.response && error.response.data,
        };
        copyTextToClipboard(JSON.stringify(debugPayload, null, 2));
        window.alert('Error capturado. Detalles copiados al portapapeles.');
      }
    } finally {
      setIsUploadingIneBack(false);
    }
  };

  const handleSiguienteUpload = async () => {
    setClabeTouched(true);
    setSubmitClabeError('');
    setManualRfcTouched(shouldRequireManualRfc);
    setDocumentsTouched(true);

    const invalidFormAlertMessage = 'Completa los campos del formulario para continuar';

    if (!hasUploadedFotoRostro || !hasUploadedIneFront || !hasUploadedIneBack || !hasUploadedCaratula) {
      alerts(invalidFormAlertMessage, true);
      return;
    }
    if (!/^\d{18}$/.test(clabe)) {
      alerts(invalidFormAlertMessage, true);
      return;
    }
    if (clabe !== confirmarClabe) {
      alerts(invalidFormAlertMessage, true);
      return;
    }
    if (shouldRequireManualRfc && !manualRfcRegex.test(manualRfc)) {
      alerts(invalidFormAlertMessage, true);
      return;
    }
    if (!csfStatus) {
      setCsfStatusTouched(true);
      alerts(invalidFormAlertMessage, true);
      return;
    }

    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';
    if (!candidateObjectId) {
      setSubmitClabeError('No se encontró el identificador de la sesión. Por favor inicia sesión de nuevo.');
      return;
    }

    try {
      setIsSubmittingClabe(true);
      const updatePayload = {
        ObjectId: candidateObjectId,
        clabe_Bancaria: clabe,
      };
      if (shouldRequireManualRfc) {
        updatePayload.manual_rfc = manualRfc;
      }
      const updateResponse = await AuthService.updateCandidate(updatePayload);
      const updateData = updateResponse && updateResponse.data;

      if (debugMode) {
        await copyTextToClipboard(JSON.stringify(updateData || {}, null, 2));
        window.alert('Respuesta de CandidateUpdate (CLABE) copiada al portapapeles.');
      }

      if (updateData && updateData.success === true) {
        syncPreRegistrationSessionFromResponse(updateData);
        setSavedClabeBancaria(clabe);
      } else {
        setSubmitClabeError((updateData && updateData.message) || 'No fue posible guardar la CLABE.');
      }

      setCurrentStep(8);
      return;
    } catch (error) {
      const backendMessage = error && error.response && error.response.data && error.response.data.message;
      setSubmitClabeError(backendMessage || 'No fue posible guardar la CLABE. Inténtalo de nuevo.');
      if (debugMode) {
        copyTextToClipboard(JSON.stringify({ errorMessage: error && error.message, status: error && error.response && error.response.status, data: error && error.response && error.response.data }, null, 2));
        window.alert('Error capturado. Detalles copiados al portapapeles.');
      }
      setCurrentStep(8);
    } finally {
      setIsSubmittingClabe(false);
    }
  };

  const handleOpenCaratulaSelector = () => {
    if (isUploadingCaratula) {
      return;
    }
    setUploadCaratulaError('');
    if (caratulaInputRef.current) {
      caratulaInputRef.current.value = '';
      caratulaInputRef.current.click();
    }
  };

  const handleBancoChange = async (event) => {
    const newBanco = event && event.target ? event.target.value : '';
    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';

    setBanco(newBanco);
    setHasSavedBanco(false);

    if (!candidateObjectId || !newBanco) {
      return;
    }

    try {
      setIsSavingBanco(true);
      const updateResponse = await AuthService.updateCandidate({
        ObjectId: candidateObjectId,
        banco: newBanco,
      });
      const updateData = updateResponse && updateResponse.data;

      if (updateData && updateData.success === true) {
        syncPreRegistrationSessionFromResponse(updateData);
        setHasSavedBanco(true);
      }
    } finally {
      setIsSavingBanco(false);
    }
  };

  const handleOpenTmLitePopup = () => {
    setShowTmLitePopup(true);
  };

  const handleCancelTmLitePopup = () => {
    setShowTmLitePopup(false);
  };

  const handleEnterTmLite = () => {
    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';

    setShowTmLitePopup(false);
    setHasUploadedCsf(false);
    setHasRequestedManualCsfReview(false);
    setUploadCsfError('');
    setShowCsfManualReviewHint(false);
    setManualRfc('');
    setManualRfcTouched(false);

    if (!candidateObjectId) {
      setUseTmLiteMode(true);
      return;
    }

    setIsUploadingCsf(true);
    AuthService.updateCandidate({
      ObjectId: candidateObjectId,
      csf_status: 'noCSF',
    })
      .then((updateResponse) => {
        const updateData = updateResponse && updateResponse.data;
        if (updateData && updateData.success === true) {
          syncPreRegistrationSessionFromResponse(updateData);
          setCsfStatus('noCSF');
        }
      })
      .finally(() => {
        setUseTmLiteMode(true);
        setIsUploadingCsf(false);
      });
  };

  const handleRestoreCsfButtons = () => {
    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';

    setHasUploadedCsf(false);
    setHasRequestedManualCsfReview(false);
    setUploadCsfError('');
    setShowCsfManualReviewHint(false);
    setManualRfc('');
    setManualRfcTouched(false);

    if (!candidateObjectId) {
      setUseTmLiteMode(false);
      return;
    }

    setIsUploadingCsf(true);
    AuthService.updateCandidate({
      ObjectId: candidateObjectId,
      csf_status: '',
    })
      .then((updateResponse) => {
        const updateData = updateResponse && updateResponse.data;
        if (updateData && updateData.success === true) {
          syncPreRegistrationSessionFromResponse(updateData);
          setCsfStatus('');
        }
      })
      .finally(() => {
        setUseTmLiteMode(false);
        setIsUploadingCsf(false);
      });
  };

  const handleRequestManualCsfReview = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';
    if (!candidateObjectId) {
      return;
    }

    try {
      setIsUploadingCsf(true);
      const updateResponse = await AuthService.updateCandidate({
        ObjectId: candidateObjectId,
        csf_status: 'Manual',
      });
      const updateData = updateResponse && updateResponse.data;

      if (updateData && updateData.success === true) {
        syncPreRegistrationSessionFromResponse(updateData);
        setUploadCsfError('');
        setShowCsfManualReviewHint(false);
        setHasRequestedManualCsfReview(true);
        setCsfStatus('Manual');
      }
    } finally {
      setIsUploadingCsf(false);
    }
  };

  const handleCsfFileChange = async (event) => {
    const file = event && event.target && event.target.files && event.target.files[0];
    setUploadCsfError('');
    setShowCsfManualReviewHint(false);
    setHasRequestedManualCsfReview(false);
    setManualRfc('');
    setManualRfcTouched(false);

    if (!file) {
      return;
    }

    if (!isAllowedFileType(file)) {
      setHasUploadedCsf(false);
      setUploadCsfError('Formato inválido. Solo se permiten JPG, PNG, TIFF o PDF.');
      return;
    }

    if (file.size > maxUploadSizeBytes) {
      setHasUploadedCsf(false);
      setUploadCsfError('El archivo supera el máximo permitido de 10 MB.');
      return;
    }

    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';
    if (!candidateObjectId) {
      setHasUploadedCsf(false);
      setUploadCsfError('No se encontró el identificador de la sesión. Por favor inicia sesión de nuevo.');
      return;
    }

    try {
      setIsUploadingCsf(true);

      const uploadResponse = await AuthService.uploadCandidateDocument('csf', file);
      const s3Location = uploadResponse && uploadResponse.data && uploadResponse.data.uploaded && uploadResponse.data.uploaded[0] && uploadResponse.data.uploaded[0].location;
      const s3DownloadUrl = uploadResponse && uploadResponse.data && uploadResponse.data.uploaded && uploadResponse.data.uploaded[0] && uploadResponse.data.uploaded[0].downloadUrl;

      if (!s3Location || !s3DownloadUrl) {
        setHasUploadedCsf(false);
        setUploadCsfError('La respuesta del servidor de archivos no contiene la ubicación del documento.');
        return;
      }

      const updateResponse = await AuthService.updateCandidate({
        ObjectId: candidateObjectId,
        s3_csf_file: s3Location,
        s3_Signed_csf: s3DownloadUrl,
      });
      const updateData = updateResponse && updateResponse.data;

      if (debugMode) {
        await copyTextToClipboard(JSON.stringify(updateData || {}, null, 2));
        window.alert('Respuesta de CandidateUpdate copiada al portapapeles.');
      }

      if (!updateData || updateData.success !== true) {
        setHasUploadedCsf(false);
        setUploadCsfError((updateData && updateData.message) || 'El servidor no pudo actualizar el documento del candidato.');
        return;
      }

      syncPreRegistrationSessionFromResponse(updateData);

      const validateResponse = await AuthService.validateCSF(candidateObjectId);
      const validateData = validateResponse && validateResponse.data;

      if (validateData && validateData.success === true) {
        const validStatusResponse = await AuthService.updateCandidate({
          ObjectId: candidateObjectId,
          csf_status: 'Valid',
        });
        const validStatusData = validStatusResponse && validStatusResponse.data;

        if (!validStatusData || validStatusData.success !== true) {
          setHasUploadedCsf(false);
          setUploadCsfError((validStatusData && validStatusData.message) || 'No fue posible actualizar el estado del CSF.');
          return;
        }

        syncPreRegistrationSessionFromResponse(validStatusData);
        setCsfStatus('Valid');
        setUseTmLiteMode(false);
        setHasUploadedCsf(true);
        setUploadCsfError('');
        setShowCsfManualReviewHint(false);
        setHasRequestedManualCsfReview(false);
        return;
      }

      setHasUploadedCsf(false);
      setUploadCsfError((validateData && validateData.message) || 'Error al validar el CSF');
      setShowCsfManualReviewHint(true);
    } catch (error) {
      setHasUploadedCsf(false);
      const backendMessage = error && error.response && error.response.data && error.response.data.message;
      setUploadCsfError(backendMessage || 'No fue posible cargar el archivo. Inténtalo de nuevo.');
      if ((backendMessage || '').toLowerCase().includes('validar el csf')) {
        setShowCsfManualReviewHint(true);
      }
      if (debugMode) {
        copyTextToClipboard(JSON.stringify({ errorMessage: error && error.message, status: error && error.response && error.response.status, data: error && error.response && error.response.data }, null, 2));
        window.alert('Error capturado. Detalles copiados al portapapeles.');
      }
    } finally {
      setIsUploadingCsf(false);
    }
  };

  const handleCaratulaFileChange = async (event) => {
    const file = event && event.target && event.target.files && event.target.files[0];
    setUploadCaratulaError('');

    if (!file) { return; }

    if (!isAllowedFileType(file)) {
      setHasUploadedCaratula(false);
      setUploadCaratulaError('Formato inválido. Solo se permiten JPG, PNG, TIFF o PDF.');
      return;
    }

    if (file.size > maxUploadSizeBytes) {
      setHasUploadedCaratula(false);
      setUploadCaratulaError('El archivo supera el máximo permitido de 10 MB.');
      return;
    }

    const candidateObjectId = localStorage.getItem(preRegSessionKeys.ObjectId) || '';
    if (!candidateObjectId) {
      setHasUploadedCaratula(false);
      setUploadCaratulaError('No se encontró el identificador de la sesión. Por favor inicia sesión de nuevo.');
      return;
    }

    try {
      setIsUploadingCaratula(true);

      const uploadResponse = await AuthService.uploadCandidateDocument('caratulaBancaria', file);
      const s3Location = uploadResponse && uploadResponse.data && uploadResponse.data.uploaded && uploadResponse.data.uploaded[0] && uploadResponse.data.uploaded[0].location;
      const s3DownloadUrl = uploadResponse && uploadResponse.data && uploadResponse.data.uploaded && uploadResponse.data.uploaded[0] && uploadResponse.data.uploaded[0].downloadUrl;

      if (!s3Location || !s3DownloadUrl) {
        setHasUploadedCaratula(false);
        setUploadCaratulaError('La respuesta del servidor de archivos no contiene la ubicación del documento.');
        return;
      }

      const updateResponse = await AuthService.updateCandidate({
        ObjectId: candidateObjectId,
        s3_caratula_bancaria: s3Location,
        s3_Signed_caratula_bancaria: s3DownloadUrl,
      });
      const updateData = updateResponse && updateResponse.data;

      if (debugMode) {
        await copyTextToClipboard(JSON.stringify(updateData || {}, null, 2));
        window.alert('Respuesta de CandidateUpdate copiada al portapapeles.');
      }

      if (updateData && updateData.success === true) {
        syncPreRegistrationSessionFromResponse(updateData);
        setHasUploadedCaratula(true);
        return;
      }

      setHasUploadedCaratula(false);
      setUploadCaratulaError((updateData && updateData.message) || 'El servidor no pudo actualizar el documento del candidato.');
    } catch (error) {
      setHasUploadedCaratula(false);
      const backendMessage = error && error.response && error.response.data && error.response.data.message;
      setUploadCaratulaError(backendMessage || 'No fue posible cargar el archivo. Inténtalo de nuevo.');
      if (debugMode) {
        copyTextToClipboard(JSON.stringify({ errorMessage: error && error.message, status: error && error.response && error.response.status, data: error && error.response && error.response.data }, null, 2));
        window.alert('Error capturado. Detalles copiados al portapapeles.');
      }
    } finally {
      setIsUploadingCaratula(false);
    }
  };

  const heroClassName = `prereg-step1-hero${currentStep === 3 ? ' prereg-step3-hero' : ''}`;
  const shouldHideHero = shouldShowPasswordForm || shouldShowProfileUploadStep || shouldShowNextScreen;
  const contentClassName = `prereg-step1-content${shouldHideHero ? ' prereg-password-content' : ''}${shouldShowProfileUploadStep || shouldShowNextScreen ? ' prereg-upload-content' : ''}${shouldShowProgramFinalScreen ? ' prereg-program-final-content' : ''}`;

  return (
    <div className={`prereg-step1-page${shouldShowProfileUploadStep || shouldShowNextScreen ? ' prereg-upload-page' : ''}`}>
      <div className="prereg-step1-card">
        {!shouldHideHero ? <div className={heroClassName} /> : null}

        <div className={contentClassName}>
          {hasActivePreRegistrationSession ? (
            <div className="prereg-active-session-box">
              <div className="prereg-active-session-name">Bienvenido {preRegistrationSession.name}</div>
              <div className="prereg-active-session-email">Cuenta: {preRegistrationSession.email}</div>
              <button type="button" className="prereg-active-session-logout" onClick={handleClosePreRegistrationSession}>Cerrar Sesión</button>
            </div>
          ) : null}

          {shouldShowSignedInError ? (
            <div className="prereg-step1-error">{signedInErrorMsg}</div>
          ) : null}

          {shouldShowRecidError ? (
            <div className="prereg-step1-error">{noRecruiterErrorMsg}</div>
          ) : null}

          {shouldShowContent && showIntroOptions ? (
            <>
              <h1 className="prereg-step1-title">
                <span>Todo empieza</span>
                <span className="prereg-step1-title-green">cuando compartes</span>
              </h1>

              <p className="prereg-step1-description">
                Completa tus datos y descubre cómo formar parte del programa de Embajadores Thermomix, una comunidad de personas que comparten, inspiran y transforman cocinas todos los días.
              </p>

              <div className="prereg-step1-actions">
                <button type="button" className="prereg-step1-action-button" onClick={() => {
                  clearSubAccountSessionStorage();
                  setShowAccountLookupScreen(false);
                  resetLookupFlow();
                  setCurrentStep(1);
                  setShowIntroOptions(false);
                }}>QUIERO GANARME UNA TM7 Y NUNCA LO HE INTENTADO</button>
                <button type="button" className="prereg-step1-action-button" onClick={() => {
                  clearSubAccountSessionStorage();
                  setShowAccountLookupScreen(true);
                  resetLookupFlow();
                  setCurrentStep(1);
                  setShowIntroOptions(false);
                }}>YA HE SIDO PARTE DE THERMOMIX Y QUIERO REINGRESAR</button>
                <button type="button" className="prereg-step1-action-button prereg-step1-action-button-small" onClick={() => {
                  setShowAccountLookupScreen(false);
                  resetLookupFlow();
                  setCandidateSignInTouched(false);
                  setCandidateSignInError('');
                  setCurrentStep(6);
                  setShowIntroOptions(false);
                }}>Me registré hace menos de 30 días, quiero concluir mi registro</button>
              </div>
            </>
          ) : null}

          {shouldShowCandidateSignInForm ? (
            showAccountLookupScreen ? (
              <div className="prereg-form">
                <div className="prereg-form-step">1/3</div>
                <h3 className="prereg-signin-title">Busca tu cuenta</h3>

                <label className="prereg-label">Ingresa tu Email, CURP o RFC</label>
                <input
                  type="text"
                  className="prereg-input"
                  value={candidateSignInData.email}
                  onChange={(e) => setCandidateSignInData((prev) => ({
                    ...prev,
                    email: e.target.value.replace(/["']/g, '').slice(0, 120),
                  }))}
                />
              </div>
            ) : (
              <div className="prereg-signin-screen">
                <h3 className="prereg-signin-title">Completa tu PreRegistro usando tu cuenta</h3>

                <input
                  type="text"
                  className="prereg-input"
                  placeholder="Correo"
                  value={candidateSignInData.email}
                  onChange={(e) => setCandidateSignInData((prev) => ({
                    ...prev,
                    email: normalizeEmail(e.target.value),
                  }))}
                />

                <input
                  type="password"
                  className="prereg-input"
                  placeholder="Contraseña"
                  value={candidateSignInData.password}
                  onChange={(e) => setCandidateSignInData((prev) => ({
                    ...prev,
                    password: sanitizePasswordValue(e.target.value),
                  }))}
                />

                {candidateSignInTouched && !isCandidateSignInEmailValid ? (
                  <div className="prereg-curp-error">Ingresa un correo válido.</div>
                ) : null}
                {candidateSignInTouched && candidateSignInData.password.length === 0 ? (
                  <div className="prereg-curp-error">Ingresa tu contraseña.</div>
                ) : null}
                {candidateSignInError ? (
                  <div className="prereg-curp-error">{candidateSignInError}</div>
                ) : null}

                <div className="prereg-submit-holder prereg-signin-submit-holder">
                  <button type="button" className="prereg-next prereg-prev" onClick={() => {
                    setCandidateSignInData({ email: '', password: '' });
                    setCandidateSignInTouched(false);
                    setCandidateSignInError('');
                    setShowIntroOptions(true);
                    setCurrentStep(1);
                  }}>REGRESAR</button>
                  <button type="button" className="prereg-next prereg-signin-submit" onClick={handleCandidateSignInSubmit} disabled={isCandidateSigningIn}>{isCandidateSigningIn ? 'Iniciando...' : 'Iniciar Sesión'}</button>
                </div>
              </div>
            )
          ) : null}

          {shouldShowStep1Form ? (
            <div className="prereg-form">
              <div className="prereg-form-step">1/3</div>

              {shouldShowStep1AccountLookup ? (
                <>
                  <h3 className="prereg-signin-title">Busca tu cuenta</h3>
                  <label className="prereg-label">Ingresa tu Email, CURP o RFC</label>
                  <input
                    type="text"
                    className="prereg-input prereg-account-lookup-input"
                    value={candidateSignInData.email}
                    onChange={(e) => {
                      setAccountLookupError('');
                      setAccountLookupSuccess('');
                      setCandidateSignInData((prev) => ({
                        ...prev,
                        email: e.target.value.replace(/["']/g, '').slice(0, 120),
                      }));
                    }}
                  />
                  {accountLookupError ? <div className="prereg-field-error">{accountLookupError}</div> : null}
                  <div className="prereg-submit-holder prereg-account-lookup-submit-holder">
                    <button type="button" className="prereg-next prereg-account-lookup-submit" onClick={handleAccountLookupSearch} disabled={isSearchingAccountLookup}>{isSearchingAccountLookup ? 'Buscando...' : 'Buscar'}</button>
                    {accountLookupSuccess ? <span className="prereg-account-lookup-success">{accountLookupSuccess}</span> : null}
                  </div>

                  <div className="prereg-form-row-two">
                    <div className="prereg-field-col">
                      <input
                        type="text"
                        className="prereg-input"
                        placeholder="Nombre(s)"
                        value={formData.nombres}
                        onChange={(e) => handleInputChange('nombres', normalizeName(e.target.value))}
                      />
                      {step1Touched && step1Validation.errors.nombres ? (
                        <div className="prereg-field-error">{step1Validation.errors.nombres}</div>
                      ) : null}
                    </div>
                    <div className="prereg-field-col">
                      <input
                        type="text"
                        className="prereg-input"
                        placeholder="Apellido(s)"
                        value={formData.apellidos}
                        onChange={(e) => handleInputChange('apellidos', normalizeName(e.target.value))}
                      />
                      {step1Touched && step1Validation.errors.apellidos ? (
                        <div className="prereg-field-error">{step1Validation.errors.apellidos}</div>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : (
                <div className="prereg-form-row-two">
                  <div className="prereg-field-col">
                    <input
                      type="text"
                      className="prereg-input"
                      placeholder="Nombre(s)"
                      value={formData.nombres}
                      onChange={(e) => handleInputChange('nombres', normalizeName(e.target.value))}
                    />
                    {step1Touched && step1Validation.errors.nombres ? (
                      <div className="prereg-field-error">{step1Validation.errors.nombres}</div>
                    ) : null}
                  </div>
                  <div className="prereg-field-col">
                    <input
                      type="text"
                      className="prereg-input"
                      placeholder="Apellido(s)"
                      value={formData.apellidos}
                      onChange={(e) => handleInputChange('apellidos', normalizeName(e.target.value))}
                    />
                    {step1Touched && step1Validation.errors.apellidos ? (
                      <div className="prereg-field-error">{step1Validation.errors.apellidos}</div>
                    ) : null}
                  </div>
                </div>
              )}

              <input
                type="text"
                className="prereg-input"
                placeholder="Teléfono Celular (10 dígitos)"
                value={formData.telefono}
                onChange={(e) => handleInputChange('telefono', normalizePhone(e.target.value))}
              />
              {step1Touched && step1Validation.errors.telefono ? (
                <div className="prereg-field-error">{step1Validation.errors.telefono}</div>
              ) : null}

              {!shouldShowStep1AccountLookup ? (
                <>
                  <input
                    type="text"
                    className="prereg-input"
                    placeholder="CURP"
                    value={formData.curp}
                    onChange={(e) => {
                      setCurpValidationError('');
                      handleInputChange('curp', normalizeCurp(e.target.value));
                    }}
                  />

                  {isValidatingCurp ? (
                    <div className="prereg-field-error">Validando CURP...</div>
                  ) : null}
                  {curpValidationError ? (
                    <div className="prereg-field-error">{curpValidationError}</div>
                  ) : null}
                  {step1Touched && step1Validation.errors.curp ? (
                    <div className="prereg-field-error">{step1Validation.errors.curp}</div>
                  ) : null}
                </>
              ) : null}

              <label className="prereg-label">¿Tienes una Thermomix® en casa?</label>
              <select
                className="prereg-select"
                value={formData.tieneThermomix}
                onChange={(e) => handleInputChange('tieneThermomix', e.target.value)}
              >
                <option value="">Selecciona una opción</option>
                <option value="NO">No</option>
                <option value="TM7">Sí, una TM7</option>
                <option value="TM6_PREV">Sí, una TM6 o modelo previo</option>
              </select>
              {step1Touched && step1Validation.errors.tieneThermomix ? (
                <div className="prereg-field-error">{step1Validation.errors.tieneThermomix}</div>
              ) : null}

              <label className="prereg-label">¿Has visto una demostración Thermomix®?</label>
              <div className="prereg-toggle-row">
                <button type="button" className={`prereg-toggle ${formData.vioDemo === 'SI' ? 'active' : ''}`} onClick={() => handleToggle('vioDemo', 'SI')}>Sí</button>
                <button type="button" className={`prereg-toggle ${formData.vioDemo === 'NO' ? 'active' : ''}`} onClick={() => handleToggle('vioDemo', 'NO')}>No</button>
              </div>
              {step1Touched && step1Validation.errors.vioDemo ? (
                <div className="prereg-field-error">{step1Validation.errors.vioDemo}</div>
              ) : null}

              <label className="prereg-label">¿Has vendido algún producto antes?</label>
              <div className="prereg-vendido-row">
                <div className="prereg-toggle-row">
                  <button type="button" className={`prereg-toggle ${formData.haVendido === 'SI' ? 'active' : ''}`} onClick={() => handleToggle('haVendido', 'SI')}>Sí</button>
                  <button type="button" className={`prereg-toggle ${formData.haVendido === 'NO' ? 'active' : ''}`} onClick={() => handleToggle('haVendido', 'NO')}>No</button>
                </div>

                <input
                  type="text"
                  className="prereg-input prereg-cual-input"
                  placeholder="¿Cuál?"
                  value={formData.cualVendio}
                  onChange={(e) => handleInputChange('cualVendio', normalizeFreeText(e.target.value))}
                  disabled={formData.haVendido === 'NO'}
                />
              </div>
              {step1Touched && step1Validation.errors.haVendido ? (
                <div className="prereg-field-error">{step1Validation.errors.haVendido}</div>
              ) : null}
              {step1Touched && step1Validation.errors.cualVendio ? (
                <div className="prereg-field-error">{step1Validation.errors.cualVendio}</div>
              ) : null}

              <div className="prereg-step2-actions">
                <button type="button" className="prereg-next prereg-prev" onClick={() => {
                  setShowAccountLookupScreen(false);
                  resetLookupFlow();
                  setShowIntroOptions(true);
                  setCurrentStep(1);
                }}>REGRESAR</button>
                <button type="button" className="prereg-next" onClick={handleSubmit}>SIGUIENTE</button>
              </div>
            </div>
          ) : null}

          {shouldShowStep2Form ? (
            <div className="prereg-form">
              <div className="prereg-form-step">2/3</div>

              <textarea
                className="prereg-input prereg-textarea"
                placeholder="Descríbete brevemente, ¿qué te gusta hacer? ¿Cuál es tu actividad favorita?"
                value={formStep2Data.descripcion}
                onChange={(e) => handleStep2InputChange('descripcion', normalizeDescription(e.target.value))}
              />
              {step2Touched && step2Validation.errors.descripcion ? (
                <div className="prereg-field-error">{step2Validation.errors.descripcion}</div>
              ) : null}

              <div className="prereg-form-row-two">
                <div className="prereg-field-col">
                  <select
                    className="prereg-select"
                    value={formStep2Data.estado}
                    onChange={(e) => handleStep2InputChange('estado', e.target.value)}
                  >
                    <option value="">Estado</option>
                    {estadosOptions.map((estadoOption) => (
                      <option key={estadoOption.value} value={estadoOption.value}>{estadoOption.label}</option>
                    ))}
                  </select>
                  {step2Touched && step2Validation.errors.estado ? (
                    <div className="prereg-field-error">{step2Validation.errors.estado}</div>
                  ) : null}
                </div>
                <div className="prereg-field-col">
                  <input
                    type="text"
                    className="prereg-input"
                    placeholder="Ciudad / Municipio"
                    value={formStep2Data.ciudad}
                    onChange={(e) => handleStep2InputChange('ciudad', normalizeAddressText(e.target.value))}
                  />
                  {step2Touched && step2Validation.errors.ciudad ? (
                    <div className="prereg-field-error">{step2Validation.errors.ciudad}</div>
                  ) : null}
                </div>
              </div>

              <input
                type="text"
                className="prereg-input"
                placeholder="Código Postal"
                value={formStep2Data.codigoPostal}
                onChange={(e) => handleStep2InputChange('codigoPostal', normalizeZipCode(e.target.value))}
              />
              {step2Touched && step2Validation.errors.codigoPostal ? (
                <div className="prereg-field-error">{step2Validation.errors.codigoPostal}</div>
              ) : null}

              <input
                type="text"
                className="prereg-input"
                placeholder="Colonia"
                value={formStep2Data.colonia}
                onChange={(e) => handleStep2InputChange('colonia', normalizeAddressText(e.target.value))}
              />
              {step2Touched && step2Validation.errors.colonia ? (
                <div className="prereg-field-error">{step2Validation.errors.colonia}</div>
              ) : null}

              <input
                type="text"
                className="prereg-input"
                placeholder="Calle"
                value={formStep2Data.calle}
                onChange={(e) => handleStep2InputChange('calle', normalizeAddressText(e.target.value))}
              />
              {step2Touched && step2Validation.errors.calle ? (
                <div className="prereg-field-error">{step2Validation.errors.calle}</div>
              ) : null}

              <div className="prereg-form-row-two">
                <div className="prereg-field-col">
                  <input
                    type="text"
                    className="prereg-input"
                    placeholder="Número Ext"
                    value={formStep2Data.numeroExterior}
                    onChange={(e) => handleStep2InputChange('numeroExterior', normalizeAddressText(e.target.value))}
                  />
                  {step2Touched && step2Validation.errors.numeroExterior ? (
                    <div className="prereg-field-error">{step2Validation.errors.numeroExterior}</div>
                  ) : null}
                </div>
                <div className="prereg-field-col">
                  <input
                    type="text"
                    className="prereg-input"
                    placeholder="Número Int"
                    value={formStep2Data.numeroInterior}
                    onChange={(e) => handleStep2InputChange('numeroInterior', normalizeAddressText(e.target.value))}
                  />
                  {step2Touched && step2Validation.errors.numeroInterior ? (
                    <div className="prereg-field-error">{step2Validation.errors.numeroInterior}</div>
                  ) : null}
                </div>
              </div>

              <label className="prereg-label">¿Qué horarios tienes disponibles para dedicarle a Thermomix?</label>
              <select
                className="prereg-select"
                value={formStep2Data.horarioDisponible}
                onChange={(e) => handleStep2InputChange('horarioDisponible', e.target.value)}
              >
                <option value="">Selecciona una opción</option>
                <option value="MANANA">Mañana</option>
                <option value="TARDE">Tarde</option>
                <option value="FIN_DE_SEMANA">Fin de semana</option>
              </select>
              {step2Touched && step2Validation.errors.horarioDisponible ? (
                <div className="prereg-field-error">{step2Validation.errors.horarioDisponible}</div>
              ) : null}

              <div className="prereg-step2-actions">
                <button type="button" className="prereg-next prereg-prev" onClick={() => setCurrentStep(1)}>ANTERIOR</button>
                <button type="button" className="prereg-next" onClick={handleStep2Submit}>SIGUIENTE</button>
              </div>
            </div>
          ) : null}

          {shouldShowStep3Form ? (
            <div className="prereg-form prereg-account-form">
              <div className="prereg-form-step prereg-step3-indicator">3/3</div>

              <h2 className="prereg-step3-title">
                <span>Ahora</span>
                <span className="prereg-step3-title-green">crea tu cuenta</span>
              </h2>

              <input
                type="text"
                className="prereg-input"
                placeholder="Mail"
                value={accountEmail}
                onChange={(e) => {
                  setSubmitCandidateError('');
                  setMailValidationError('');
                  setAccountEmail(normalizeEmail(e.target.value));
                }}
              />

              {isValidatingMail ? (
                <div className="prereg-curp-error">Validando Mail...</div>
              ) : null}
              {isValidatingReingresoEmail ? (
                <div className="prereg-curp-error">Validando Mail...</div>
              ) : null}
              {mailValidationError ? (
                <div className="prereg-curp-error">{mailValidationError}</div>
              ) : null}
              {step3Touched && submitCandidateError ? (
                <div className="prereg-curp-error">{submitCandidateError}</div>
              ) : null}

              {showAccountLookupScreen && accountLookupResult ? (
                <div className="prereg-account-lookup-success prereg-account-email-hint">Correo registrado: {maskEmailForDisplay(accountLookupResult.email || '')}</div>
              ) : null}

              <label className="prereg-privacy-row">
                <input
                  type="checkbox"
                  className="prereg-privacy-checkbox"
                  checked={acceptedPrivacy}
                  onChange={(e) => setAcceptedPrivacy(e.target.checked)}
                />
                <span>
                  Al aceptar confirmas que leíste y estás de acuerdo con el{' '}
                  <a className="prereg-privacy-link" href="https://www.thermomix.mx/politica-privacidad/" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>
                </span>
              </label>

              {step3Touched && !isStep3EmailValid ? <div className="prereg-curp-error">Ingresa un correo válido.</div> : null}
              {step3Touched && !acceptedPrivacy ? <div className="prereg-curp-error">Debes aceptar el Aviso de Privacidad.</div> : null}

              <div className="prereg-submit-holder">
                <button type="button" className="prereg-next prereg-step3-submit" onClick={handleStep3Submit}>Crea tu cuenta</button>
              </div>
            </div>
          ) : null}

          {shouldShowPasswordForm ? (
            <div className="prereg-password-screen">
              <img className="prereg-password-logo" src="/assets/img/thermomix_header_2023.png" alt="Thermomix" />
              <h3 className="prereg-password-title">Crea tu contraseña</h3>

              <input
                type="password"
                className="prereg-input prereg-password-input"
                placeholder="Contraseña"
                value={passwordData.password}
                onChange={(e) => handlePasswordChange('password', sanitizePasswordValue(e.target.value))}
              />

              <input
                type="password"
                className="prereg-input prereg-password-input"
                placeholder="Confirmar contraseña"
                value={passwordData.confirmPassword}
                onChange={(e) => handlePasswordChange('confirmPassword', sanitizePasswordValue(e.target.value))}
              />

              {passwordTouched && !isPasswordSecure ? (
                <div className="prereg-curp-error">La contraseña debe tener al menos 8 caracteres, mayúscula, minúscula, número y símbolo.</div>
              ) : null}
              {passwordTouched && isPasswordSecure && !isPasswordMatch ? (
                <div className="prereg-curp-error">Las contraseñas no coinciden.</div>
              ) : null}
              {submitCandidateError ? (
                <div className="prereg-curp-error">{submitCandidateError}</div>
              ) : null}

              <div className="prereg-submit-holder prereg-password-submit-holder">
                <button type="button" className="prereg-next prereg-step3-submit" onClick={handleCreateAccount} disabled={isSubmittingCandidate}>{isSubmittingCandidate ? 'Guardando...' : 'Crea tu cuenta'}</button>
              </div>
            </div>
          ) : null}

          {shouldShowThankYou ? (
            <div className="prereg-thankyou-screen">
              <h2 className="prereg-thankyou-title">{isSessionRedirect ? '¡Hola!' : '¡Gracias!'}</h2>
              <p className="prereg-thankyou-copy">
                <span className="prereg-thankyou-copy-green">Ya casi entras a ganarte tu TM7.</span>
                <span>Si tienes dudas contacta a tu reclutador</span>
              </p>
              <div className="prereg-submit-holder prereg-thankyou-action">
                <button type="button" className="prereg-next prereg-step3-submit" onClick={() => setCurrentStep(7)}>Completa tu perfil</button>
              </div>
            </div>
          ) : null}

          {shouldShowProfileUploadStep ? (
            <div className="prereg-upload-screen">
              <div className="prereg-upload-step">1/2</div>
              <h3 className="prereg-upload-title">Carga los siguientes archivos</h3>

              <div className="prereg-upload-row">
                <div className="prereg-upload-label">Foto Personal (Rostro)</div>
                <div className="prereg-upload-action-row">
                  <button type="button" className="prereg-upload-btn" onClick={handleOpenFotoRostroSelector} disabled={isUploadingFotoRostro}>{isUploadingFotoRostro ? 'Cargando...' : 'Cargar archivo'}</button>
                  {hasUploadedFotoRostro ? <span className="prereg-upload-ok">✓</span> : null}
                </div>
                <input
                  ref={fotoRostroInputRef}
                  type="file"
                  className="prereg-hidden-file-input"
                  accept=".jpg,.jpeg,.png,.tif,.tiff,.pdf"
                  onChange={handleFotoRostroFileChange}
                />
                {uploadFotoRostroError ? <div className="prereg-field-error prereg-upload-error">{uploadFotoRostroError}</div> : null}
                {documentsTouched && !hasUploadedFotoRostro && !uploadFotoRostroError ? <div className="prereg-field-error prereg-upload-error">Sube este documento para continuar.</div> : null}
              </div>

              <div className="prereg-upload-row">
                <div className="prereg-upload-label">INE anverso</div>
                <div className="prereg-upload-action-row">
                  <button type="button" className="prereg-upload-btn" onClick={handleOpenIneFrontSelector} disabled={isUploadingIneFront}>{isUploadingIneFront ? 'Cargando...' : 'Cargar archivo'}</button>
                  {hasUploadedIneFront ? <span className="prereg-upload-ok">✓</span> : null}
                </div>
                <input
                  ref={ineFrontInputRef}
                  type="file"
                  className="prereg-hidden-file-input"
                  accept=".jpg,.jpeg,.png,.tif,.tiff,.pdf"
                  onChange={handleIneFrontFileChange}
                />
                {uploadIneFrontError ? <div className="prereg-field-error prereg-upload-error">{uploadIneFrontError}</div> : null}
                {documentsTouched && !hasUploadedIneFront && !uploadIneFrontError ? <div className="prereg-field-error prereg-upload-error">Sube este documento para continuar.</div> : null}
              </div>

              <div className="prereg-upload-row">
                <div className="prereg-upload-label">INE reverso</div>
                <div className="prereg-upload-action-row">
                  <button type="button" className="prereg-upload-btn" onClick={handleOpenIneBackSelector} disabled={isUploadingIneBack}>{isUploadingIneBack ? 'Cargando...' : 'Cargar archivo'}</button>
                  {hasUploadedIneBack ? <span className="prereg-upload-ok">✓</span> : null}
                </div>
                <input
                  ref={ineBackInputRef}
                  type="file"
                  className="prereg-hidden-file-input"
                  accept=".jpg,.jpeg,.png,.tif,.tiff,.pdf"
                  onChange={handleIneBackFileChange}
                />
                {uploadIneBackError ? <div className="prereg-field-error prereg-upload-error">{uploadIneBackError}</div> : null}
                {documentsTouched && !hasUploadedIneBack && !uploadIneBackError ? <div className="prereg-field-error prereg-upload-error">Sube este documento para continuar.</div> : null}
              </div>

              <div className="prereg-upload-row">
                <div className="prereg-upload-label">Carátula bancaria</div>
                <div className="prereg-upload-action-row">
                  <button type="button" className="prereg-upload-btn" onClick={handleOpenCaratulaSelector} disabled={isUploadingCaratula}>{isUploadingCaratula ? 'Cargando...' : 'Cargar archivo'}</button>
                  {hasUploadedCaratula ? <span className="prereg-upload-ok">✓</span> : null}
                </div>
                <input
                  ref={caratulaInputRef}
                  type="file"
                  className="prereg-hidden-file-input"
                  accept=".jpg,.jpeg,.png,.tif,.tiff,.pdf"
                  onChange={handleCaratulaFileChange}
                />
                {uploadCaratulaError ? <div className="prereg-field-error prereg-upload-error">{uploadCaratulaError}</div> : null}
                {documentsTouched && !hasUploadedCaratula && !uploadCaratulaError ? <div className="prereg-field-error prereg-upload-error">Sube este documento para continuar.</div> : null}
              </div>

              <div className="prereg-clabe-field-group">
                <label className="prereg-label">Selecciona un Banco</label>
                <div className="prereg-upload-action-row">
                  <select
                    className="prereg-select"
                    value={banco}
                    onChange={handleBancoChange}
                    disabled={isSavingBanco}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancoOptions.map((bancoOption) => (
                      <option key={bancoOption.value} value={bancoOption.value}>{bancoOption.label}</option>
                    ))}
                  </select>
                  {hasSavedBanco ? <span className="prereg-upload-ok">✓</span> : null}
                </div>
              </div>

              <div className="prereg-clabe-field-group">
                {clabe.length > 0 ? <div className="prereg-clabe-floating-label">CLABE INTERBANCARIA</div> : null}
                <div className="prereg-clabe-input-row">
                  <input
                    type="text"
                    inputMode="numeric"
                    className="prereg-upload-mock-input prereg-upload-mock-input-field"
                    placeholder="CLABE INTERBANCARIA"
                    maxLength={18}
                    value={clabe}
                    onChange={(e) => setClabe(e.target.value.replace(/\D/g, '').slice(0, 18))}
                  />
                  {isClabeSaved ? <span className="prereg-upload-ok prereg-clabe-ok">✓</span> : null}
                </div>
              </div>
              {clabeTouched && !/^\d{18}$/.test(clabe) ? (
                <div className="prereg-field-error">La CLABE debe ser de exactamente 18 dígitos.</div>
              ) : null}
              <div className="prereg-clabe-field-group">
                {confirmarClabe.length > 0 ? <div className="prereg-clabe-floating-label">CONFIRMAR CLABE INTERBANCARIA</div> : null}
                <div className="prereg-clabe-input-row">
                  <input
                    type="text"
                    inputMode="numeric"
                    className="prereg-upload-mock-input prereg-upload-mock-input-field"
                    placeholder="CONFIRMAR CLABE INTERBANCARIA"
                    maxLength={18}
                    value={confirmarClabe}
                    onChange={(e) => setConfirmarClabe(e.target.value.replace(/\D/g, '').slice(0, 18))}
                  />
                  {isClabeSaved ? <span className="prereg-upload-ok prereg-clabe-ok">✓</span> : null}
                </div>
              </div>
              {clabeTouched && /^\d{18}$/.test(clabe) && clabe !== confirmarClabe ? (
                <div className="prereg-field-error">Las CLABEs no coinciden.</div>
              ) : null}

              <div className="prereg-upload-row prereg-upload-row-csf">
                <div className="prereg-upload-label">Constancia de Situación Fiscal</div>
                {hasUploadedCsf || !useTmLiteMode ? (
                  <div className="prereg-upload-action-row">
                    <button type="button" className="prereg-upload-btn" onClick={handleOpenCsfSelector} disabled={isUploadingCsf || hasUploadedCsf}>{isUploadingCsf ? 'Cargando...' : 'Cargar archivo'}</button>
                    {hasUploadedCsf ? <span className="prereg-upload-ok">✓</span> : null}
                    {hasRequestedManualCsfReview ? <span className="prereg-upload-ok prereg-upload-ok-warning">✓</span> : null}
                    {!hasUploadedCsf ? <button type="button" className="prereg-upload-btn prereg-upload-alt-btn" onClick={handleOpenTmLitePopup}>No tengo CSF</button> : null}
                  </div>
                ) : (
                  <div className="prereg-upload-action-row prereg-upload-tmlite-row">
                    <button type="button" className="prereg-upload-btn" onClick={handleRestoreCsfButtons}>Registrarme con CSF</button>
                    <span className="prereg-upload-tmlite-note">Ingresa con tu CSF para obtener más beneficios</span>
                  </div>
                )}
                <input
                  ref={csfInputRef}
                  type="file"
                  className="prereg-hidden-file-input"
                  accept=".jpg,.jpeg,.png,.tif,.tiff,.pdf"
                  onChange={handleCsfFileChange}
                />
                {hasUploadedCsf ? <div className="prereg-upload-success">CSF validado.</div> : null}
                {hasRequestedManualCsfReview ? <div className="prereg-upload-warning">Validación manual de CSF</div> : null}
                {csfStatusTouched && !csfStatus && !uploadCsfError ? (
                  <div className="prereg-field-error prereg-upload-error">Sube tu CSF o selecciona una opción para continuar.</div>
                ) : null}
                {uploadCsfError ? <div className="prereg-field-error prereg-upload-error">{uploadCsfError}</div> : null}
                {showCsfManualReviewHint ? (
                  <div className="prereg-field-error prereg-upload-error prereg-csf-manual-review">
                    Cárgala nuevamente o <button type="button" className="prereg-csf-manual-review-link" onClick={handleRequestManualCsfReview}>solicita una revisión manual.</button>
                  </div>
                ) : null}
              </div>

              {shouldRequireManualRfc ? (
                <>
                  <div className="prereg-clabe-field-group">
                    {manualRfc.length > 0 ? <div className="prereg-clabe-floating-label">RFC</div> : null}
                    <input
                      type="text"
                      className="prereg-upload-mock-input prereg-upload-mock-input-field"
                      placeholder="RFC"
                      maxLength={13}
                      value={manualRfc}
                      onChange={(e) => setManualRfc(normalizeManualRfc(e.target.value))}
                    />
                  </div>
                  {manualRfcTouched && !manualRfcRegex.test(manualRfc) ? (
                    <div className="prereg-field-error">RFC inválido</div>
                  ) : null}
                </>
              ) : null}

              {submitClabeError ? <div className="prereg-curp-error">{submitClabeError}</div> : null}

              <div className="prereg-submit-holder prereg-upload-next-holder">
                <button type="button" className="prereg-next prereg-upload-next" onClick={handleSiguienteUpload} disabled={isSubmittingClabe}>{isSubmittingClabe ? 'Guardando...' : 'SIGUIENTE'}</button>
              </div>

              {showTmLitePopup ? (
                <div className="prereg-tmlite-modal-backdrop">
                  <div className="prereg-tmlite-modal">
                    <img className="prereg-tmlite-modal-image" src="/assets/img/Aviso_PopUp_TM_Lite-V2.png" alt="Aviso TM Lite" />
                    <div className="prereg-tmlite-modal-actions">
                      <button type="button" className="prereg-upload-btn prereg-tmlite-modal-btn" onClick={handleEnterTmLite}>Ingresar a TM Lite</button>
                      <button type="button" className="prereg-upload-btn prereg-tmlite-modal-btn" onClick={handleCancelTmLitePopup}>Cancelar</button>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}

          {shouldShowNextScreen ? (
            <div className="prereg-upload-screen prereg-program-screen">
              <div className="prereg-upload-step">2/2 Elige tu programa</div>

              {selectedProgram === 'GANA_TU_THERMOMIX' ? (
                <img className="prereg-program-image" src="/assets/img/Programa_Gana_Tu_TM.png" alt="Programa Gana tu Thermomix" />
              ) : null}
              {selectedProgram === 'TM_SIN_BARRERAS' ? (
                <img className="prereg-program-image" src="/assets/img/Programa_TM_Sin_Barreras.png" alt="Programa TM Sin Barreras" />
              ) : null}
              {selectedProgram === 'TM_LITE' ? (
                <img className="prereg-program-image" src="/assets/img/Programa_TM7_Lite.png" alt="Programa TM Lite" />
              ) : null}
              {selectedProgram === 'TM_ELITE' ? (
                <img className="prereg-program-image" src="/assets/img/Programa_TM_Elite.png" alt="Programa TM Elite" />
              ) : null}
              {!selectedProgram ? (
                <h3 className="prereg-upload-title prereg-program-title">Programas de Ingreso</h3>
              ) : null}

              <div className="prereg-program-select-group">
                <label className="prereg-program-select-label" htmlFor="prereg-program-select">Elige tu programa</label>
                <select
                  id="prereg-program-select"
                  className="prereg-select prereg-program-select"
                  value={selectedProgram}
                  onChange={handleProgramSelectionChange}
                  disabled={isSavingProgramSelection}
                >
                  <option value="">Elige tu Programa</option>
                  {shouldLimitProgramsToTmLite ? (
                    <option value="TM_LITE">TM Lite</option>
                  ) : (
                    <>
                      <option value="GANA_TU_THERMOMIX">Gana tu Thermomix</option>
                      <option value="TM_SIN_BARRERAS">TM Sin Barreras (exclusivo BDMs)</option>
                      <option value="TM_ELITE">TM Elite</option>
                    </>
                  )}
                </select>
                {hasSavedProgramSelection ? <span className="prereg-upload-ok prereg-program-select-ok">✓</span> : null}
              </div>
              {programTouched && !hasSavedProgramSelection ? (
                <div className="prereg-field-error prereg-upload-error">Debes elegir un programa</div>
              ) : null}

              <div className="prereg-program-contract-row">
                <button type="button" className="prereg-upload-btn prereg-program-contract-btn" onClick={handleSignContract}>Firmar contrato</button>
                {hasSignedContract ? <span className="prereg-upload-ok prereg-program-contract-ok">✓</span> : null}
                <span className="prereg-program-contract-copy">• Este documento debe estar legalmente firmado por el titular de la documentación entregada</span>
              </div>
              {contractTouched && !hasSignedContract ? (
                <div className="prereg-field-error prereg-upload-error">Firma el documento para continuar</div>
              ) : null}

              <div className="prereg-submit-holder prereg-upload-next-holder prereg-program-next-holder">
                <button type="button" className="prereg-next prereg-upload-next" onClick={handleProgramNext}>SIGUIENTE</button>
              </div>
            </div>
          ) : null}

          {shouldShowProgramFinalScreen ? (
            <div className="prereg-program-final-screen">
              {showProgramFinalMessage ? (
                <div className="prereg-program-final-message">
                  <h2 className="prereg-program-final-title">¡Felicidades!</h2>
                  <p className="prereg-program-final-copy prereg-program-final-copy-green">Nuestro equipo revisará tus documentos y te contactaremos en caso de ser necesario</p>
                  <p className="prereg-program-final-copy">Una vez que quede procesada tu alta, recibirás un mail</p>
                </div>
              ) : programFinalSteps.map((stepLabel, index) => {
                const isVisible = index < visibleProgramFinalSteps;
                const stepStatus = programFinalStepStatuses[index];
                const stepError = programFinalStepErrors[index];
                const isStepResultVisible = stepStatus === 'success' || stepStatus === 'error';
                const isStepError = stepStatus === 'error';

                return (
                  <div key={stepLabel}>
                    <div className={`prereg-program-final-row${isVisible ? ' is-visible' : ''}`}>
                      <span className="prereg-program-final-text">{stepLabel}</span>
                      <span className={`prereg-upload-ok prereg-program-final-check${isStepResultVisible ? ' is-visible' : ''}${isStepError ? ' prereg-program-final-check-error' : ''}`}>{isStepError ? '✕' : '✓'}</span>
                    </div>
                    {isStepError && stepError ? (
                      <div className="prereg-field-error prereg-program-final-error">{stepError}</div>
                    ) : null}
                  </div>
                );
              })}
              {programFinalFailed ? (
                <div className="prereg-submit-holder prereg-upload-next-holder prereg-program-next-holder">
                  <button type="button" className="prereg-next prereg-upload-next" onClick={() => window.location.reload()}>REINTENTAR</button>
                </div>
              ) : null}
            </div>
          ) : null}

          {shouldShowSignedInError ? (
            <div className="prereg-step1-signedin-actions">
              <button type="button" className="prereg-step1-signedin-button" onClick={goHome}>Regresar</button>
              <button type="button" className="prereg-step1-signedin-button" onClick={signOutAndGoHome}>Cerrar sesión</button>
            </div>
          ) : null}

          {!shouldHideHero && !shouldShowThankYou ? <img className="prereg-step1-footer-logo" src="/assets/img/thermomix_header_2023.png" alt="Thermomix" /> : null}
        </div>
      </div>
    </div>
  );
}
